import React from "react";
import styled from "styled-components";
import "react-step-progress-bar/styles.css";
import DefaultInputClaroSocio from "../inputsClaroSocio/DefaultInputClaroSocio";
import ContactInputClaroSocio from "../inputsClaroSocio/ContactInputClaroSocio";
import AmountInputClaroSocio from "../inputsClaroSocio/AmountInputClaroSocio";
import ChipInputClaroSocio from "../inputsClaroSocio/ChipInputClaroSocio";
import SelectInputClaroSocio from "../inputsClaroSocio/SelectInputClaroSocio";
import CommisionModule from "../inputsClaroSocio/CommisionModule";
import SelectCardClaroSocio from "../inputsClaroSocio/SelectCardClaroSocio";
import CvvInputClaroSocio from "../inputsClaroSocio/CvvInputClaroSocio";
import DescriptionInputClaroSocio from "../inputsClaroSocio/DescriptionInputClaroSocio";
import { ClaroTooltip, ClaroModalCustom, ClaroCardSimple } from "@claropay/shared";
import { useClaropaySdk } from "../../../services/sdk/SDKServiceWeb.tsx";
import ModalCardOk from "../../molecules/ModalCardOk";
import { mask } from "../GenericForm/utils/maskAmount";
import { floatToInteger } from "../GenericForm/utils/floatToInteger";
import { formatToCurrency } from "../GenericForm/utils/formatToCurrency";
import {
	getValueFromReference,
	handleValidation,
} from "../inputsClaroSocio/utils/index";
import {
	selectPaymentServiceContacts,
	selectOCRScannerData,
	getCanSendId,
	getHasCreditFromUrl,
	getBundleVersionFromUrl,
	getUserInfoSelector,
	selectPaymentServiceConf,
	getListFavsServices,
	getListReminder,
	getTokenizationCardSelector,
	getTokenizationOnSelector,
	getCanRegisterEmailSelector,
	getLoadingTokenizationCardSelector,
	getCanMultiAnalytics,
	getOriginParamsSelector,
	getCanTapToAppSelector,
	getTapToAppParamsSelector,
	getVerifyNfcSelector,
	getResponseReadingNfcSelector,
	getCanCheckBalanceN2,
} from "../../../store/selectors/paymentsSelectors";
import ClaroButton from "../../atoms/ClaroButton";
import ClaroLoadBtn from "../../atoms/ClaroLoadBtn";
import {
	getPaymentMethods,
	getAmountOfTelcelPospago,
	setSelectedChipValues,
	getCommissionInfo,
	addContactToRecents,
	setCreditCardInfo,
	setTrackSteps,
	getOCRScanner,
	executeTaggeo,
	setShowAdvancementMiniBanner,
	setAdvancementPayMethod,
	setPaymentMethod,
	setStartEventOnboardingIsOver,
	setTokenizationCard,
	setSnackBarSuccess,
	setLoadingTokenizationCard,
	setVerifyNfc,
	setResponseReadingNfc,
	setOpenPayMethodModal,
	setOpenFluxAddCard
} from "../../../store/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as sdkclaro from "@claropay/claro-pay-sdk-v2";
import { GenericFormContext } from "../../../context/genericFormContext";
import ClaroPadding from "../../atoms/ClaroPadding";
import ClaroParagraph from "../../atoms/ClaroParagraph";
import ClaroChipsBlock from "../../organisms/ClaroChipsBlock";
import ModalCardLoader from "../../molecules/ModalCardLoader";
import { assignTagServiceTelcel, getMessage, validateUserAgent, isObjectEmpty, idIsvalidCheckBalanceArcus} from "../utils";
import {
	AMOUNT_MIN_TO_USE_CREDIT,
	CREDIT_CLARO_PAY,
	AMIGO_PAGUITOS,
	servicesIdTAE,
	TELMEX,
	CFE,
	TELNOR,
	NATURGY,
	DISH,
    BLUE_TELECOM, 
    ATT ,
    SKY ,
    AGUA_PUEBLA ,
    INFONAVIT ,
    MOVISTAR_POSTPAGO ,
    TELEVIA, 
    PASE ,
    NATURA ,
    AVON ,
    MEGACABLE_26_DIGITS ,
    TOTALPLAY ,
	TELCEL_IDS,
	SERVICE_ID_TELCEL_RECARGA,
	CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE,
	CATEGORY_PLANS_ID_PAQUETE_INTERNET_AMIGO,
	SERVICE_ID_TELCEL_POSPAGO,
	ARCUS_BILLER_IDS,
	ADVANCEMENT_CLARO_PAY,
	SERVICE_ID_TELCEL_PLANES,
	ADVANCEMENT_CARD_INFO,
	TELCEL_POSPAGO_MICROAPP_ID,
	CATEGORY_PLANS_ID_PAQUETE_POR_TIEMPO,
	SERVICE_ID_TELCEL_PAQUETES_POSPAGO,
	CATEGORY_PLANS_ID_PAQUETE_MAS_DATOS,
	CATEGORY_PLANS_ID_PAQUETE_MAS_DATOS_MIXTO,
	SERVICE_ID_TELCEL_PAQUETES_MIXTOS,
	SKYPS,
	MUEVECDMX,
	TYPE_MODAL_BALANCE_CERO,
	TYPE_MODAL_BALANCE_ERROR, 
	PAGO_SERVICIOS_SCANNER,
	PAGO_SERVICIOS_CHECK_BALANCE,
	PAGO_SERVICIOS_PAY_METHOD,
	PAGO_SERVICIOS_FORM_LOAD
} from "../../../constants";
import { calculateOriginPayment } from "../GenericForm/utils/calculateOriginPayment";
import ModalValidationNumberAP from "../ModalValidationNumberAP";
import { findPaymentMethodFromFluxAddCard } from "./utils.js/findPaymentMethodFromFluxAddCard";
import ButtonBoxContainer from "../../containers/ButtonBoxContainer";
import SelectCardAnonimous from "../inputsClaroSocio/SelectCardClaroSocio/selectCardAnonimous";
import ModalCardHE from "../../molecules/ModalCardHE";
import { getHasDomiciliation } from "../../../store/actions/domiciliation.js";
import { findReference } from "./utils.js/findReference.js";
import { getUserApplyForAdvance } from "../utils";
import CarouselMegasTelcel from "../CarouselMegasTelcel/index.js";
import PlansUpsell from "../PlansUpsell/index.js";
import { calculateProductId } from "../GenericForm/utils/calculateProductId.js";
import { existConfigFavorites } from "../utils";
import Snackbar from "../Snackbars/completeInformation.js";
import { buttonDomiciliationConfigExist, getServicesTelcel, getCvvWithTokenizationResponse } from "../utils";
import TokenizationCardContainer from "../../containers/TokenizationCardContainer.js";
import ModalCloseModal from "../../molecules/ModalCloseModal/index.js";
import TermsAndPrivacy from "../../molecules/TermsAndPrivacy/TermsAndPrivacy.js";
import ModalMessaging from "../../molecules/ModalMessaging/index.js";
import ModalCheckBalanceTelcel from "../../molecules/ModalCheckBalanceContainer.js";
import { startFeaturedDatadog, succedFeaturedDatadog, failedFeaturedDatadog } from '../../organisms/utils.js';
import { ClaroSDKService } from '../../../services/sdk/ClaroSDKService.js';

const Container = styled.div`
  width: 100%;
  margin-bottom:  ${props => props.os == "android" ? "0px" : "30%"};
  position: relative;
  z-index: 0;
`;

const Text_CS_TooltipTitle = () => {
	return (
		<span>
			Encuentra la línea de captura
			<br />
			en tu recibo como indica la guía
		</span>
	);
};


class BodyPaymentFormClaroSocio extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.buttonSubmitRef = React.createRef();
		const { 
            paymentMethods
        } = this.props
        const isAnonimous = this.props.isAnonimous || (paymentMethods.cardList && paymentMethods.cardList.length === 0 && !paymentMethods.hasN2)
				? true
				: false;
				console.log("paymentMethods",this.props.isAnonimous,  paymentMethods, isAnonimous)

		this.state = {
			dataConfigInputs: this.props.dataConfigInputs,
			addCloseEfect: false,
			textTitleTooltip: "",
			textTitleTooltipMargin: "",
			imgTooltip: "",
			imgTooltipPosition: null,
			imgTooltipWidth: null,
			openToolTip: false,
			openSelectCardClaroSocio: false,
			valueSelectInput: "",
			destAccountIdValue: "",
			contactsValue: "",
			valueCardId: "",
			valuetChipInput: "",
			valueChipProductId: "",
			valueCvv: "",
			valueDescription: "",
			mark: "",
			isValidAmount: false,
			isValidOcr: true,
			isValidContacts: true,
			isValidSelectPaymentMethod: true,
			isValidCvv: true,
			isValidDescription: true,
			isValidCardId: true,
			setFromOcrScannerData: false,
			setAmountTelcelPospago: false,
			setContactsValue: true,
			commissionData: [],
			setCommissionRules: true,
			_item: [],
			openModalTelcel: false,
			imgModalTelcel:
				"data:image/png;base64,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",
			titleModalTelcel: "TITLE",
			subtitleModalTelcel: "",
			setDefaultAmount: true,
			setDefaultOcrValue: true,
			setDefaultContactsValue: true,
			setDefaultSelectValue: true,
			visibleInputCvv: false,
			buttonState: {
				disabled: true,
			},
			buttonText: "Pagar",
			inputsvalidated: [],
			openModalUpdateCard: false,
			heightTooltip: "85%",
			heightImg: "",
			fontSizeTitleTooltip: "12px",
			fontColorTooltip: "#B2B2B2",
			textSubtitle: "",
			responseCodeMessage: "",
			responseCode: "",
			discount: [],
			totalCommission: 0,
			setValueCvv: false,
			limitCountPaymentMethodsCall: 2,
			disabledAmountInput: false,
			scanErrorDestAccountIdValue: "",
			scanError: false,
			discountCredit: {
				amountWithoutDiscount: 0,
				discountPercentage: 0,
				discountAmount: 0,
				discountFixedAmount: 0,
				amountWithoutCommissions: 0,
			},
			inquiryTelmexId: "",
			amountMinAlert: false,
			marginButtonContinue: "0px 4% 4% 4%",
			//pospagoAlertState: POSPAGO_ALERT_INITIAL_STATE,
			buttonTextTelcel: "Entendido",
			errorCode36_TELMEX: {
				subTitleStyle: {
					color: "red",
					margin: "0.5rem 0rem 0rem 0rem",
				},
				text: "El número de cliente es incorrecto",
				visible: false,
			},
			itemDistpatchGetAmount: false,
			itemDistpatchGetAmountLength: 0,
			modalValidationNumberAPIsOpen: false,
			modalValidationNumberAPCase: 0, // 1 -> TECEL REDIRECT TO AP | 2 -> AP REDIRECT TO TELCEL
			modalValidationNumberAPTitle: 'TITLE',
			modalValidationNumberAPSubtitle: 'SUBTITLE',
			ModalValidationNumberAPBtn1Text: 'BTN1',
			ModalValidationNumberAPBtn2Text: 'BTN2',
			setAutomaticOnclick: true,
			isDisabledButtonArcusGetAmount: true,
			openAlertNoPendingAmount: false,
			initialCreditCardInfo: this.props.creditCardInfo,
			openSelectCardAnonimous: false,
			isAnonimous: isAnonimous,
			isOpenModalCardHE: false,
			userInfoState: {},			
			megasGiftImageUrl: "", // Imagen que se envia a ticket de confirmación diciendo los megas de regalo
			fromListFavorites: false,
			isOpenCompleteInformationSnackBar: false,
			submitFormAutomaticForAnonimous: false,
			showAdvancementPayMethod: false,
            tokenizationCardState: undefined,
            setPaymentMethodInfoState: undefined,
			showTokenizationCard: false,
			tokenizarionResponse: undefined,
			cvvWithTokenizationResponse: false,
			redirectToAutoSumbit: false,
			updateWithTokenization: undefined,
			submitClicled: false,
			openModalComissionError: false,
			tapToapp: false,
			showBannerTapToApp: true,
			openNFCSettings: false,
			openModalNfcMessages: false,
			isCardCustomer: undefined,
			modalMessaging: {
        		show: false,
        		flux: undefined,
        		code: undefined,
      		},
			checkBalanceArcusModalContainerIsVisible : false,
			typeModalContainerChekBalance: TYPE_MODAL_BALANCE_CERO,
			destAccountInput: this.props.dataConfigInputs.find(input => input.id === "destAccountId")
		};
	}

	componentDidMount() {		
		const {
			dataConfigInputs,
			sdkVersion,
			serviceInfo,
			productIdFromPlan,
			amountPlan,
			serviceId,
			selectedChipValues,
			lineNumber,
			isClaroPartner,
			paramsNewOfferTelcel,
			contactNumber,
			appSyncValues,
			isContainerTelcel
		} = this.props;
		
		isClaroPartner && servicesIdTAE.includes(serviceId)
			? this.setState({ buttonText: 'Siguiente' })
			: this.setState({ buttonText: this.state.buttonText });

		if (
			sdkVersion !== undefined && 
			(!this.state.isAnonimous || this.props.addCardFormData.handleSetDefaultPaymentMethod)
		) {
			this.setDefaultPaymentMethod();
		}

		if (serviceInfo.logicType == "claroVideo") {
			this.setState({
				buttonText: "Contrátalo  Ahora",
				showClaroVideoTitle: true,
			});
		}

		this.isButtonSubmitDisabled();
		if (productIdFromPlan && serviceId !== SERVICE_ID_TELCEL_RECARGA) {
			this.setState({ valueChipProductId: productIdFromPlan });
			this.props.setSelectedChipValues(productIdFromPlan, amountPlan);
			this.context.getAmountFromOcrData(amountPlan);
		}
		if (serviceId == 113) {
			this.context.getAmountFromOcrData(0);
			const object = selectedChipValues;
			if (object) {
				Object.keys(object).forEach((key) => (object[key] = null));
			}
		}
		if (serviceInfo.logicType == "sears" && amountPlan) {
			this.context.getAmountFromOcrData(formatToCurrency(amountPlan));
			this.setState({ marginButtonContinue: "4% 20%" });
		}
		// Bandera para evitar que al negar permisos de contactos se regrese mas de una pantalla en la navegación
		window.backContacts = false;

		if (
			(lineNumber && lineNumber.length === 10 && serviceId == TELMEX) ||
			(lineNumber && lineNumber.length === 10 && serviceId == SERVICE_ID_TELCEL_POSPAGO) ||
			(paramsNewOfferTelcel && serviceId === SERVICE_ID_TELCEL_POSPAGO) 
		) {
			const lineNumberValue = paramsNewOfferTelcel ? paramsNewOfferTelcel.line : lineNumber
			this.setState({
				destAccountIdValue: lineNumberValue,
				isValidOcr: true,
				setAmountTelcelPospago: true,
				setDefaultOcrValue: false,
			});
			let inputsForValidationArray = this.props.dataConfigInputs.filter(
				(element) => {
					if (element.field) {
						if (this.props.sdkVersion !== undefined) {
							return (
								(element.field.input.value == "" ||
									element.field.input.value == undefined) &&
								element.field.input.logicType == undefined &&
								element.constraints
							);
						} else {
							return (
								(element.field.input.value == "" ||
									element.field.input.value == undefined) &&
								element.constraints &&
								element.id != "cardId" &&
								element.id != "cvv"
							);
						}
					}
				}
			);
			inputsForValidationArray = (inputsForValidationArray? inputsForValidationArray : []).find((it) => it.id === "destAccountId");
			if(inputsForValidationArray){
				this.addItemValidated(inputsForValidationArray.type === "ocr"? "isValidOcr" : "isValidContacts");
			}
			if(!paramsNewOfferTelcel) {
				this.props.getAmountOfTelcelPospago(lineNumberValue, serviceId);
				if(serviceId === SERVICE_ID_TELCEL_POSPAGO && !this.props.isContainerTelcel){
					this.props.getHasDomiciliation(lineNumber, serviceId);
				}
			}
		}
		if (
			serviceId === SERVICE_ID_TELCEL_RECARGA || 
			serviceInfo.categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE
			) {
				const { selectedChipValues } = this.props 
				if(selectedChipValues && selectedChipValues.amountValue){
          this.handleSetAdvancementPayMethod(selectedChipValues.amountValue);
        }
			if (
				isNaN(lineNumber) === false &&
				lineNumber &&
				lineNumber.length === 10
			) {
				this.setState({
					contactsValue: contactNumber ? contactNumber : lineNumber,
					setContactsValue: false,
					setDefaultContactsValue: false,
					destAccountIdValue: contactNumber ? contactNumber : lineNumber, // esto porque el tipo de field es contact en lugar ade OCR
				});
				this.addItemValidated("isValidContacts");
			}
			const {paymentAmountFromUrl, productIdFromUrl, setSelectedChipValues } = this.props

			if(serviceId === SERVICE_ID_TELCEL_RECARGA && paymentAmountFromUrl && productIdFromUrl){
				setTimeout(() => {
					setSelectedChipValues(productIdFromUrl, paymentAmountFromUrl);
					this.handleInputClick(event, "select-chips", [], paymentAmountFromUrl, productIdFromUrl)
				}, 1200);
			}
			if(serviceId === SERVICE_ID_TELCEL_RECARGA 
				&& this.props.paramsFromurl && this.props.paramsFromurl.actionMA
					&& this.props.paramsFromurl.paymentAmount){
				setTimeout(() => {
					console.debug("_set package from actionMA")
					console.debug(this.props.paramsFromurl)
					const ammountInput = this.props.dataConfigInputs.find((it) => it.id === "amount");
					if(ammountInput && ammountInput.field 
						&& ammountInput.field.itemsList && ammountInput.field.itemsList.length){
							const itemsListSelected = ammountInput.field.itemsList.find((it) => it.amount === parseInt(this.props.paramsFromurl.paymentAmount));
							console.debug(itemsListSelected)
							if(itemsListSelected){
								setSelectedChipValues(itemsListSelected.productID, itemsListSelected.amount);
								this.handleInputClick(event, "select-chips", [], itemsListSelected.amount, itemsListSelected.productID)
								const element = document.getElementById(itemsListSelected.amount);
								if(element){
									const rect = element.getBoundingClientRect();
									const x = rect.left + window.scrollX;
									const y = rect.top + window.scrollY;
									document.getElementById("content-chips").scrollLeft += (x-10);
								}
							}
					}
				}, 1800);
			}
		}
		if((lineNumber && lineNumber.length === 12 && serviceId === CFE) ||
		(lineNumber &&(lineNumber.length === 13 || lineNumber.length === 14) && serviceId === DISH)  ||
		(lineNumber && lineNumber.length === 12 && serviceId === BLUE_TELECOM)  ||
		(lineNumber && lineNumber.length === 12 && serviceId === SKY)  ||
		(lineNumber && lineNumber.length === 12 && serviceId === SKYPS)  ||
		(lineNumber && lineNumber.length === 16 && serviceId === MUEVECDMX)  ||
		(lineNumber && lineNumber.length === 7 && serviceId === AGUA_PUEBLA)  ||
		(lineNumber && lineNumber.length === 10 && serviceId === INFONAVIT)  ||
		(lineNumber && lineNumber.length === 10 && serviceId === MOVISTAR_POSTPAGO)  ||
		(lineNumber && lineNumber.length === 12 && serviceId === TELEVIA)  ||
		(lineNumber && lineNumber.length === 13 && serviceId === PASE)  ||
		(lineNumber && lineNumber.length === 11 && serviceId === NATURA)  ||
		(lineNumber && lineNumber.length === 20 && serviceId === AVON)  ||
		(lineNumber &&(lineNumber.length === 10 || lineNumber.length === 26) && serviceId === MEGACABLE_26_DIGITS)  ||
		(lineNumber &&(lineNumber.length === 10 || lineNumber.length === 17) && serviceId === TOTALPLAY) ||
		(lineNumber && lineNumber.length === 10 && serviceId === TELNOR) ||
		(lineNumber && lineNumber.length === 11 && serviceId === NATURGY)
	){
			this.setState({
				contactsValue: lineNumber,
				destAccountIdValue: lineNumber,
				isValidOcr: true,
				fromListFavorites: true,
				setDefaultOcrValue: false,
			});
		}
		if (
			lineNumber && lineNumber.length === 10 && serviceId === ATT
		) {
			this.setState({
				contactsValue: lineNumber,
				setContactsValue: false,
				fromListFavorites: true,
				setDefaultContactsValue: false,
				destAccountIdValue: lineNumber, // esto porque el tipo de field es contact en lugar ade OCR
			});
			this.addItemValidated("isValidContacts");
		}

		if (paramsNewOfferTelcel) {
			const { line, cvv: { cvvValue, isRequiredCvv } } = paramsNewOfferTelcel
			if (
				serviceInfo.categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE ||
				serviceId === SERVICE_ID_TELCEL_RECARGA ||
				(
					serviceId === SERVICE_ID_TELCEL_PAQUETES_POSPAGO &&
					serviceInfo.categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_MAS_DATOS
				) ||
				(
					serviceId === SERVICE_ID_TELCEL_PAQUETES_MIXTOS &&
					serviceInfo.categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_MAS_DATOS_MIXTO
				)
			) {
				this.setState({
					contactsValue: contactNumber ? contactNumber : line,
					setContactsValue: false,
					setDefaultContactsValue: false,
					destAccountIdValue: contactNumber ? contactNumber : line,

				});
				this.addItemValidated("isValidContacts");
			}
			if (
				serviceId === SERVICE_ID_TELCEL_POSPAGO &&
				serviceInfo.categoryPlansId === undefined
			) {
				setTimeout(() => {
					let inputsForValidationArray = this.props.dataConfigInputs.filter(
						(element) => {
							if (element.field) {
								if (this.props.sdkVersion !== undefined) {
									return (
										(element.field.input.value == "" ||
											element.field.input.value == undefined) &&
										element.field.input.logicType == undefined &&
										element.constraints
									);
								} else {
									return (
										(element.field.input.value == "" ||
											element.field.input.value == undefined) &&
										element.constraints &&
										element.id != "cardId" &&
										element.id != "cvv"
									);
								}
							}
						}
					);
					inputsForValidationArray = (inputsForValidationArray? inputsForValidationArray : []).find((it) => it.id === "destAccountId");
					if(inputsForValidationArray){
						this.handleInputChange({
							target: {
								value: contactNumber ? contactNumber : line,
								name: "destAccountId"
							}
						}, inputsForValidationArray.type);
					}
					if (isRequiredCvv) {
						this.handleInputChange({
							target: {
								value: cvvValue,
								name: "cvv"
							}
						}, "isValidCvv");
					}
				}, 3500);
			}
			if (isRequiredCvv) {
				this.setState({ valueCvv: cvvValue, setValueCvv: true });
				this.addItemValidated("isValidCvv");
				setTimeout(() => {
					if (isRequiredCvv) {
						this.handleInputChange({
							target: {
								value: cvvValue,
								name: "cvv"
							}
						}, "isValidCvv");
					}
				}, 3500);
			} else {
				this.deleteItemValidated("isValidCvv");
			}
		}

		// Taggeo a facturadores arcus 
		if (ARCUS_BILLER_IDS.includes(this.props.serviceId)) {
			this.taggeoArcus("View");
		}

		// Asignación de imagen de beneficio de megas (regalito) para pospago 
		if (
			isContainerTelcel &&
			appSyncValues &&
			appSyncValues.banks &&
			appSyncValues.banks[0].properties &&
			appSyncValues.banks[0].properties.BILL_PAYMENT_BENEFIT_IMAGE &&
			serviceId === SERVICE_ID_TELCEL_POSPAGO 
		) {
			this.setState({ 
				megasGiftImageUrl: appSyncValues.banks[0].properties.BILL_PAYMENT_BENEFIT_IMAGE 
			});
		}

		if (
			(paramsNewOfferTelcel && this.state.setAutomaticOnclick) &&
			this.props.creditCardInfo &&
			this.props.creditCardInfo.value &&
			(
				serviceInfo.categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE ||
				this.props.serviceId === SERVICE_ID_TELCEL_POSPAGO || 
				(
					serviceId === SERVICE_ID_TELCEL_PAQUETES_POSPAGO &&
					serviceInfo.categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_MAS_DATOS
				) ||
				(
					serviceId === SERVICE_ID_TELCEL_PAQUETES_MIXTOS &&
					serviceInfo.categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_MAS_DATOS_MIXTO
				)
			) 
		) {
			this.props.handleShowLoaderWaitSubmit(true)
		}
	}

	handleSetAdvancementPayMethod(cost=null) {
		const {
			paymentMethods, serviceId,
			userInfo, setShowAdvancementMiniBanner,
			creditCardInfo
		} = this.props
		const canShowMiniBanner = 
			paymentMethods && 
			paymentMethods.hasAdvancement && 
			getUserApplyForAdvance(userInfo, cost )
		if (serviceId === SERVICE_ID_TELCEL_RECARGA) {
			if (canShowMiniBanner) {
				if(creditCardInfo.value !== ADVANCEMENT_CLARO_PAY){
					setShowAdvancementMiniBanner(true)
				}else{
					setShowAdvancementMiniBanner(false)
				}
				this.setState({showAdvancementPayMethod : true})
			} else{
				setShowAdvancementMiniBanner(false)
				this.setState({showAdvancementPayMethod : false})
			}
			if (
				paymentMethods &&
				(paymentMethods.cardList.length > 0 || paymentMethods.hasN2) &&
				creditCardInfo.value === ADVANCEMENT_CLARO_PAY &&
				userInfo && userInfo.advancePayment && userInfo.advancePayment.creditAmount < cost
			) {		
				this.setDefaultPaymentMethod();
			}				
		}
	}

	validateActiveN2 = () => {
		return this.props.sdkVersion < "1.0.147" ? true : this.props.activeN2;
	};

	setStepTrack = (step) => {
		if (this.props.trackId) {
			this.props.setTrackSteps(this.props.trackId, `${step}`);
		}
	};

	sendTaggeoBack = () => {
		if (this.props.canMultiAnalytics && this.props.isContainerTelcel) {
				const originAnalyticArray = this.props.originAnalytic? this.props.originAnalytic.split(",") : [];
				this.props.executeTaggeo({
					eventName: "pay_service_or_tae",
					seccion: "servicios",
					subseccion: this.props.serviceInfo && this.props.serviceInfo.serviceId && getServicesTelcel(this.props.serviceInfo.serviceId),
					origen: originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services",
					pantalla: "formulario de pago",
					nombreServicio: this.props.serviceInfo && this.props.serviceInfo.serviceName ,
					tipoElemento: "boton",
					tagTipoElemento: "modal",
					nombreElemento: "back",
					trackAction: true,
					isTelcel: true
				}, true);
		} else {
			this.props.executeTaggeo({
				step: "Formulario de pago",
				action: "Click modal Back",
				modal_id: "Ingresa una tarjeta"
			});
		}
	}

	sendTaggeoClose = (type) => {
			if (this.props.canMultiAnalytics && this.props.isContainerTelcel) {
				const originAnalyticArray = this.props.originAnalytic? this.props.originAnalytic.split(",") : [];
				if(type ==="modal") {
					this.props.executeTaggeo({
						eventName: "pay_service_or_tae",
						seccion: "servicios",
						subseccion: this.props.serviceInfo && this.props.serviceInfo.serviceId && getServicesTelcel(this.props.serviceInfo.serviceId),
						origen: originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services",
						pantalla: "formulario de pago",
						nombreServicio: this.props.serviceInfo && this.props.serviceInfo.serviceName ,
						tipoElemento: "boton",
						tagTipoElemento: "modal",
						nombreElemento: "cerrar",
						trackAction: true,
						isTelcel: true
					}, true);					
				} else {
					this.props.executeTaggeo({
						eventName: "pay_service_or_tae",
						seccion: "servicios",
						subseccion: this.props.serviceInfo && this.props.serviceInfo.serviceId && getServicesTelcel(this.props.serviceInfo.serviceId),
						origen: originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services",
						pantalla: "formulario de pago",
						nombreServicio: this.props.serviceInfo && this.props.serviceInfo.serviceName ,
						tipoElemento: "boton",
						tagTipoElemento: "modal",
						nombreElemento: "cerrar",
						trackAction: true,
					}, true);
				}
			} else {
				this.props.executeTaggeo({
					step: "Formulario de pago",
					action: "Click modal Cerrar",
					modal_id: this.props.addCardFormData.isOpenAddCardForm ? "Ingresa una tarjeta" : "Elige método de pago"
				});
			}
		}

	componentDidUpdate(prevProps, prevState) {
		const {
			setPaymentMethod,
			setPaymentMethodInfo, 
			paymentMethods,
			serviceId, 
			isClaroPartner,
			getPaymentMethods,
			setAdvancementPayMethodValue,
			setAdvancementPayMethod,
			selectedChipValues,
			verifyNfcState,
			responseReadingNFC,
			openPayMethodModal,
			setOpenPayMethodModal,
			openFluxAddCard,
			setOpenFluxAddCard,
		} = this.props;

		const { openSelectCardClaroSocio } = this.state
			if(openFluxAddCard ){
				this.handleInputClick(event, "cardId", {value: "agregar-targeta"});
				setOpenFluxAddCard(false)
			}
			if(openPayMethodModal){
				this.handleInputButtonFunction(event, "select")
				setOpenPayMethodModal(false)
			}
        if (this.props.tokenizationCard && this.props.tokenizationCard !== this.state.tokenizationCardState) {
            this.setState({
				tokenizationCardState: this.props.tokenizationCard,
			});
            if (this.props.tokenizationCard && this.props.tokenizationCard.result === "declined") {
                this.props.setTokenizationCard(undefined);
				this.setState({
					showTokenizationCard: false,
				});
            }
        }
		if(setPaymentMethodInfo && setPaymentMethodInfo !== this.state.setPaymentMethodInfoState){
			getPaymentMethods(serviceId, isClaroPartner);
			this.setState({
				setPaymentMethodInfoState: setPaymentMethodInfo,
			});
		}

		if (paymentMethods !== prevProps.paymentMethods) {
			const { cardList, hasN2 } = paymentMethods;
			if (setPaymentMethodInfo && cardList && cardList.length > 0) {
				this.handleInputClick(
					event, 
					"cardId", 
					findPaymentMethodFromFluxAddCard(setPaymentMethodInfo, cardList)
				);	
				setPaymentMethod(undefined);
				console.debug("tokenizationCard in paymentMethods")
				console.debug(this.props.tokenizationCard)
				if(this.props.tokenizationCard){
					this.props.setTokenizationCard(undefined);
					this.validateForTokenizationCard();
				}
			}
			if (this.props.startEventOnboardingIsOver) {
				if (
					paymentMethods &&
                    paymentMethods.cardList &&
                    (
						paymentMethods.cardList.length > 0 ||
                        paymentMethods.hasN2
                    )
                ) {
					this.setState({ isAnonimous: false });
					this.setDefaultPaymentMethod();
                }
				this.props.setStartEventOnboardingIsOver(false);
			}
		}

		if (this.props.isAnonimous !== prevProps.isAnonimous) {
            if (!this.props.isAnonimous) {
                const { paymentMethods } = this.props;
                if (
                    paymentMethods &&
                    paymentMethods.cardList &&
                    (
                        paymentMethods.cardList.length > 0 ||
                        paymentMethods.hasN2
                    )
                ) {
                    this.setState({ isAnonimous: false });
                    this.setDefaultPaymentMethod();
                }	
            }
        }
		if(setAdvancementPayMethodValue){
			this.handleInputClick(event, "cardId", ADVANCEMENT_CARD_INFO);
			setAdvancementPayMethod(false)
		}

		const { userInfo } = this.props;
		const { userInfoState } = this.state;
		if (userInfo && userInfoState && 
			userInfo["claro-profile.person.claroid"] !== userInfoState["claro-profile.person.claroid"]) {
			const { hasCredit, canSendId, userInfo, } = this.props;
			this.setState({
				userInfoState: userInfo,
			})
			if (userInfo && userInfo.credit &&
				userInfo.credit.score &&
				userInfo.credit.score !== null &&
				userInfo.credit.score !== false &&
				userInfo.credit.score !== "false" &&
				userInfo.credit.creditAmount &&
				userInfo.credit.creditAmount !== null &&
				userInfo.credit.creditAmount !== "0" &&
				userInfo.credit.creditAmount !== "0.00" &&
				userInfo.credit.isOnboarding === "true" &&
				userInfo.credit.accepted === "false"
			&& canSendId && this.props.serviceId !== AMIGO_PAGUITOS) {
				sdkclaro.getInstance().showCreditSnackBar(
					"snackbar_credit_services",
					() => { },
					() => { }
				);
			}
		}

		// Cambiar monto y obtener comisiones 
		// al hacer upsell
		if (prevProps.selectedPlan !== this.props.selectedPlan) {
			if (this.props.selectedPlan) {				
				if (this.props.serviceId === SERVICE_ID_TELCEL_PLANES) {
					// Set productId			
					const newProductId = calculateProductId(null, this.props.selectedPlan.cost, this.props.planCategory, this.props.selectedPlan.idExternal);
					this.setState({ valueChipProductId: newProductId});	

					// Get commissions
					const valueToCommissions = this.props.selectedPlan.cost;
					this.getCommissions(this.state.valueCardId, String(valueToCommissions));
					
					// Set amount in input
					this.context.getAmountFromOcrData(this.props.selectedPlan.cost);				
				}		
				
				if (this.props.serviceId === SERVICE_ID_TELCEL_RECARGA) {
					const value = this.props.selectedPlan.cost;
					const productId = this.props.selectedPlan.idExternal;
					this.getCommissions(this.state.valueCardId, String(value));
					this.setState({ valuetChipInput: value, valueChipProductId: productId });
					this.props.setSelectedChipValues(productId, value);
					this.context.getAmountFromOcrData(value);
					this.addItemValidated("isValidAmount");					
					this.props.handleGetSelectPlanByCost(this.props.plans, this.props.selectedPlan.cost);	
				}
			}			
		}

		if (prevProps.isLoadingCommisSionRules !== this.props.isLoadingCommisSionRules) {
			if (this.props.isLoadingCommisSionRules) {
				this.setState({ buttonState: {disabled: true} })
			} else {
				this.isButtonSubmitDisabled();
			}
		}

		if (prevProps.commissionRules !== this.props.commissionRules) {
			const {redirectToAutoSumbit, submitClicled } = this.state
			if (redirectToAutoSumbit) {
				this.setState({
					redirectToAutoSumbit: false,
					commissionData: this.props.commissionRules
				});
				this.submitFormToPayTopic();
			}
			if(submitClicled){
				this.setState({submitClicled: false });
				this.submitFormToPayTopic();
			}
		}
		const { commissionInfoError } = this.props 
		if(prevProps.commissionInfoError !== commissionInfoError){
			if(!isObjectEmpty(commissionInfoError) && commissionInfoError !== "Previous request aborted"){
				this.setState({openModalComissionError: true})
			}
		}
		if (prevProps.creditCardInfo !== this.props.creditCardInfo && this.props.creditCardInfo) {
			if (this.props.validateIfSentToTicket) {
				let inputsForValidationArray = this.props.dataConfigInputs.filter(
					(element) => {
						if (element.field) {
							return (
								(element.field.input.value == "" ||	element.field.input.value == undefined) &&
								element.field.input.logicType == undefined &&
								element.constraints &&
								element.id !== "cvv"
							);
						}
					}
				);
				let inputsValidatedArray = this.state.inputsvalidated.filter(element => element !== "isValidCvv");
				const fillFields = inputsForValidationArray.length == inputsValidatedArray.length ? true : false;

				if (!fillFields) {
					this.props.handleShowLoaderWaitSubmit(false);
					this.handleIsOpenCompleteInformationSnackBar(true);
					let exitMap = false;
					inputsForValidationArray.map(input => {
						if (
							input.constraints &&
							input.field &&
							input.field.input &&
							input.field.input.name &&
							input.id !== "cardId" &&
							!exitMap
						) {
							const constraints = typeof input.constraints === "object" && Object.keys(input.constraints).length >= 1
								? input.constraints[0]
								: input.constraints
							const regex = new RegExp(constraints);
							const name = input.field.input.name;
							const inputDom = document.querySelector(`input[name=${name}]`);
							if (inputDom && inputDom.value && !regex.test(inputDom.value)) {
								inputDom.focus();
								exitMap = true;
							}
						}
					})
				} else {
					this.setState({ submitFormAutomaticForAnonimous: true })
				}
				this.props.handleValidateIfSentToTicket(false);			
			}
			if(serviceId === SERVICE_ID_TELCEL_RECARGA && selectedChipValues){
				this.handleSetAdvancementPayMethod(selectedChipValues.amountValue);
			}
		}

		if (prevState.buttonState.disabled !== this.state.buttonState.disabled ) {
			if (!this.state.buttonState.disabled && this.state.submitFormAutomaticForAnonimous) {
				console.log('SUBMIT__')
				this.setState({ submitFormAutomaticForAnonimous: false });
				this.submitFormToPayTopic();
			}
		}
		if (this.props.verifyNfcState && !this.state.openNFCSettings !== prevState.openNFCSettings) {
			this.setState({ openNFCSettings: verifyNfcState });
		}
		if (prevProps.responseReadingNFC !== responseReadingNFC) {
			console.debug('NFC__', responseReadingNFC)
			if(responseReadingNFC.success){
				// this.setState({ openModalNfcMessages: true });
				this.submitFormToPayTopic();
			} else {
				this.setState({ openModalNfcMessages: false });
			}
		}
	}

	handleIsOpenCompleteInformationSnackBar = (value) => {
		console.log('SNACKBAR__', value)
		this.setState({isOpenCompleteInformationSnackBar: value});
	}

	handleIsOpenCompleteInformationTokenizationSnackBar = (value) => {
		this.setState({isOpenCompleteInformationTokenizationSnackBar: value});
	}

	setDefaultPaymentMethod = () => {
		let cardInfo = {};
		let defaultItemPaymentMethod = [];
		const { 
			creditCardInfo, paymentMethods, setAdvancementPayMethodValue, 
			userInfo, serviceId,
		} = this.props	
		if (creditCardInfo && creditCardInfo.value != ADVANCEMENT_CLARO_PAY && creditCardInfo.value != "agregar-targeta" &&  creditCardInfo.value != undefined) {
			cardInfo = creditCardInfo;
		} else {
			defaultItemPaymentMethod = paymentMethods.cardList.map(
				(item, index) => {
					if (item.isDefault != "0") {
						return item;
					} else {
						return false;
					}
				}
			);

			if (paymentMethods.hasN2 && this.validateActiveN2()) {
				if (defaultItemPaymentMethod[0]) {
					cardInfo = {
						value: defaultItemPaymentMethod[0].cardId,
						mark: defaultItemPaymentMethod[0].card.mark,
						type: defaultItemPaymentMethod[0].card.type,
						lastDigits: defaultItemPaymentMethod[0].card.lastDigits,
						update: false,
					};
				} else {
					cardInfo = {
						value: "claro-pay",
						mark: "999",
						type: 0,
						lastDigits: " ",
						update: false,
					};
				}
			} else {
				if (defaultItemPaymentMethod[0]) {
					cardInfo = {
						value: defaultItemPaymentMethod[0].cardId,
						mark: defaultItemPaymentMethod[0].card.mark,
						type: defaultItemPaymentMethod[0].card.type,
						lastDigits: defaultItemPaymentMethod[0].card.lastDigits,
						update: false,
					};
				} else {
					paymentMethods.cardList[0];
					cardInfo = {
						value: paymentMethods.cardList[0].cardId,
						mark: paymentMethods.cardList[0].card.mark,
						type: paymentMethods.cardList[0].card.type,
						lastDigits: paymentMethods.cardList[0].card.lastDigits,
						update: false,
					};
				}
			}
		}
		if(
			(creditCardInfo && creditCardInfo.value == ADVANCEMENT_CLARO_PAY && 
			getUserApplyForAdvance(
				userInfo, 
				serviceId === SERVICE_ID_TELCEL_RECARGA ? window.valuetChipInput : this.context.ocrAmountValue
			)) ||
			setAdvancementPayMethodValue
		){
			cardInfo = ADVANCEMENT_CARD_INFO
		}
		succedFeaturedDatadog(
			PAGO_SERVICIOS_PAY_METHOD, 
			userInfo.fullstoryIdOperationKey, 
			this.props.serviceId, 
			'Selección método de pago exitosa'
		);    
		this.setState({initialCreditCardInfo: !this.state.initialCreditCardInfo ? cardInfo : this.state.initialCreditCardInfo})
		this.handleInputClick(event, "cardId", cardInfo);
	};

	getCommissions = (cardIdValue, valueToCommissions) => {
		const { contactsValue, destAccountIdValue } = this.state;	
		if (cardIdValue) {
			let isClaroPay = cardIdValue == "claro-pay" ? true : false;
			let valueAmountString = parseFloat(valueToCommissions.replace(/,/g, ""));
			let isClaroPartner = this.props.isClaroPartner ? true : false;

			if (
				valueAmountString > 0 &&
				this.props.sdkVersion !== undefined &&
				cardIdValue != CREDIT_CLARO_PAY && cardIdValue != ADVANCEMENT_CLARO_PAY
			) {
				this.props.getCommissionInfo(
					this.props.serviceId,
					"",
					valueAmountString,
					isClaroPay,
					cardIdValue,
					this.props.sdkVersion,
					isClaroPartner,
					this.props.trackId,
					contactsValue ? contactsValue : destAccountIdValue,
				);
				this.setState({ setCommissionRules: true });
			}
		}
		
	};

	handleInputChange = (event, type) => {
		const itemName = event.target.name;
		let itemValue = event.target.value;
		let _item = _.find(this.props.dataConfigInputs, ["id", itemName]);
		const itemValueLength = itemValue.length;
		const initialPhoneNumbers = itemValue.substring(0, 2);
		let launchGetAmountTelcel = true;
		const { userInfo } = this.props
		this.setState({ 
			itemDistpatchGetAmount: _item.distpatchGetAmount ? true : false,
			itemDistpatchGetAmountLength: _item.distpatchGetAmountLength ? _item.distpatchGetAmountLength : this.state.itemDistpatchGetAmountLength
		});

		const bundleVersionFromUrl = parseInt((this.props.bundleVersion).toString().replaceAll('.', ''));
		const minFunctionalBundleVersion = parseInt((process.env.REACT_APP_BUNDLE_VERSION).replaceAll('.', ''));
		const launchModalValidationAP = bundleVersionFromUrl >= minFunctionalBundleVersion ? true : false;
		if (
			TELCEL_IDS.includes(this.props.serviceId) &&
			itemValueLength === 10 &&
			initialPhoneNumbers === '10' &&
			!this.props.isClaroPartner &&
			launchModalValidationAP
		) {
			this.setState({
				modalValidationNumberAPCase: 1,
				modalValidationNumberAPTitle: 'El número que ingresaste pertenece a un Amigo Paguitos',
				modalValidationNumberAPSubtitle: '¿Quieres pagarlo?',
				ModalValidationNumberAPBtn1Text: 'No',
				ModalValidationNumberAPBtn2Text: 'Sí',
				modalValidationNumberAPIsOpen: true
			})
			this.modalValidationNumberAPTaggeo('View alert', 1);
			launchGetAmountTelcel = false;
		}

		if(
		this.props.serviceId === AMIGO_PAGUITOS && 
		!this.props.isClaroPartner && 
		itemValueLength === 10 &&
		launchModalValidationAP && 
		initialPhoneNumbers === '10'){
			//console.warn("consulta si ya fue domiciliado amigo paguitos")
			console.warn("habilitar botón Domiciliar")
			//this.props.getHasDomiciliation(itemValue, this.props.serviceId);
		} 

		if (
			this.props.serviceId === AMIGO_PAGUITOS &&
			itemValueLength === 10 &&
			initialPhoneNumbers !== '10' &&
			!this.props.isClaroPartner
		) {
			this.setState({
				modalValidationNumberAPCase: 2,
				modalValidationNumberAPTitle: 'El número que ingresaste pertenece a un plan Telcel',
				modalValidationNumberAPSubtitle: '¿Quieres pagarlo?',
				ModalValidationNumberAPBtn1Text: 'No',
				ModalValidationNumberAPBtn2Text: 'Sí',
				modalValidationNumberAPIsOpen: true
			})
			this.modalValidationNumberAPTaggeo('View alert', 2);
			launchGetAmountTelcel = false;
		}
		const { truncateValue, truncateValueClaroSocio } = _item.field.input;
		switch (event.target.name) {
			case "amount":
				let maxAmount = _item.range ? _item.range.max : 0;
				let maskedValue = mask(itemValue, maxAmount);
				const { getAmountFromOcrData, handleSetAmountFromInput } = this.context;
				getAmountFromOcrData(maskedValue.value);
				handleSetAmountFromInput(true);
				if (!this.props.amountPlan) {
					this.inputValidation(
						parseFloat(itemValue.replace(/,/g, "")),
						_item,
						"isValidAmount"
					);
				}
				this.setState({ setDefaultAmount: false });

				this.getCommissions(this.state.valueCardId, maskedValue.value);
				break;
			case "destAccountId":
				if (truncateValue) {
					const { isClaroPartner } = this.props;
					const truncatevalueConfig =
						isClaroPartner && truncateValueClaroSocio
							? truncateValueClaroSocio
							: truncateValue;
					itemValue = event.target.value.substr(0, truncatevalueConfig);
				}
				if (type == "ocr") {
					if (_item.uppercase) {
						itemValue = itemValue.toUpperCase();
					}
					this.setState({
						destAccountIdValue: itemValue,
						setFromOcrScannerData: false,
						setDefaultOcrValue: false,
						scanErrorDestAccountIdValue: itemValue,
						errorCode36_TELMEX: {
							...this.state.errorCode36_TELMEX,
							visible: false,
						},
					});
					this.inputValidation(itemValue, _item, "isValidOcr");
					const {isContainerTelcel, serviceId} = this.props
					if (_item.distpatchGetAmount && launchGetAmountTelcel && this.state.inputsvalidated.includes("isValidOcr")) {
						if (idIsvalidCheckBalanceArcus(isContainerTelcel, serviceId)) {
							this.setState({
								isDisabledButtonArcusGetAmount: _item.distpatchGetAmountLength && itemValue.length == _item.distpatchGetAmountLength
									? false
									: true
							});
							if (_item.distpatchGetAmountLength && itemValueLength == _item.distpatchGetAmountLength) {
								this.props.getAmountOfTelcelPospago(
									itemValue,
									this.props.serviceId
								);
								this.setState({ setAmountTelcelPospago: true });
								this.setStepTrack("CS01");
								if(this.props.serviceId === SERVICE_ID_TELCEL_POSPAGO && !this.props.isContainerTelcel){
									this.props.getHasDomiciliation(itemValue, this.props.serviceId);
								}
							}
						}
						// Automatic calculation of amount for arcus billers
						startFeaturedDatadog(
							PAGO_SERVICIOS_CHECK_BALANCE, 
							userInfo.fullstoryIdOperationKey, 
							this.props.serviceId, 
							'Inicio cálculo monto automático'
						);
					}
				}
				this.setState({fromListFavorites: false})
				if (type == "contacts") {
					let contactInputValue = itemValue.replace(/\./g, "");
					const { setMask } = _item.field.input;
					const { isClaroPartner } = this.props;
					if (isClaroPartner && setMask) {
						contactInputValue = contactInputValue
							.replace(/\D/g, "")
							.replace(/(\d{2})(\d{1,2})/, "$1 $2")
							.replace(/(\d{4})(\d{1,2})/, "$1 $2");
					}
					this.setState({
						contactsValue: contactInputValue,
						setContactsValue: false,
						setDefaultContactsValue: false,
						destAccountIdValue: contactInputValue,
					});
					this.inputValidation(itemValue, _item, "isValidContacts");
					if (itemValueLength === 10 && this.props.serviceId === SERVICE_ID_TELCEL_POSPAGO) {
						this.props.getAmountOfTelcelPospago(
								itemValue,
								this.props.serviceId
						);
						this.setState({setAmountTelcelPospago: true})
					}
				}

				break;
			case "cardId":
				break;
			case "cvv":
				let value = itemValue;
				if (itemValue.length > 4) {
					value = itemValue.substr(0, 4);
				}
				this.inputValidation(value, _item, "isValidCvv");
				this.setState({ valueCvv: value, setValueCvv: true });
				break;
			case "description":
                if (truncateValue) {
                    itemValue = event.target.value.substr(0, truncateValue)
                }

				itemValue = itemValue.replace(/\p{Extended_Pictographic}/u, "");

				this.inputValidation(itemValue, _item, "isValidDescription");
				this.setState({ valueDescription: itemValue });
				break;
		}
	};

	inputValidation(itemValue, _item, inputValid) {
		const { isClaroPartner } = this.props;
		const { constraintsClaroSocio, constraints } = _item;
		const constraintsValue =
			isClaroPartner && constraintsClaroSocio
				? constraintsClaroSocio
				: constraints;
		if (constraintsValue) {

			if (handleValidation(itemValue, constraintsValue[0])) {
				this.setState({ [inputValid]: true });
				this.addItemValidated(inputValid);
				return true;
			} else {
				this.deleteItemValidated(inputValid);
				this.setState({ [inputValid]: false });
				return false;
			}
		}
		return true;
	}

	addItemValidated(itemName) {
		if (!this.state.inputsvalidated.includes(itemName)) {
			this.state.inputsvalidated.push(itemName);
			setTimeout(() => {
				this.isButtonSubmitDisabled();
			}, 200);
		}
	}

	deleteItemValidated(itemName) {
		let deleteInputsValidated = this.state.inputsvalidated.filter(function (
			item
		) {
			return item !== itemName;
		});
		this.setState({ inputsvalidated: deleteInputsValidated });
		setTimeout(() => {
			this.isButtonSubmitDisabled();
		}, 200);
	}

	taggeoArcusSaldoCero = (action,alert_id) => {
		const { executeTaggeo } = this.props;
		executeTaggeo({
			eventName: "Service_payment",
			step: "Formulario de pago",
			action: action,
			alert_id: alert_id
		});
	}
	taggeoArcus = (action) => {
		const { executeTaggeo } = this.props;
		executeTaggeo({
			eventName: "Service_payment",
			step: "Formulario de pago",
			action: action,
			service: this.props.serviceName
		});
	}
	modalValidationNumberAPTaggeo = (action, taggeoCase) => {
		const { executeTaggeo } = this.props;
		const params = {
			step: taggeoCase === 1 ? 'Formulario de pago' : 'Formulario Amigo Paguitos',
			action: action,
			Id_alert: taggeoCase === 1 ? 'Telcel a Amigo Paguitos' : 'Amigo Paguitos a plan telcel',
			service: this.props.serviceName
		}
		executeTaggeo(params);
	}
	taggeo = (action) => {
		const { originOfPayment, executeTaggeo, serviceId, tagServiceId, serviceInfo } = this.props;
		const { categoryPlansId } = serviceInfo

		if (
			(
				originOfPayment &&
				originOfPayment !== "Home" &&
				serviceId === TELMEX
			) ||
			serviceId === AMIGO_PAGUITOS ||
			categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_INTERNET_AMIGO ||
			categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE ||
			serviceId === SERVICE_ID_TELCEL_POSPAGO
		) {
			executeTaggeo({
				step: "Formulario de pago",
				action: action,
				service: tagServiceId,
				origin: calculateOriginPayment(originOfPayment),
			});
		}
	};
	setAddCardFormDataHandler = async () => {
		// Get tokens from web sdk
    const tokenFull = await ClaroSDKService.getFullToken();
    // Set token
    await useClaropaySdk().setToken(false, tokenFull);
		let isCardCustomer = await useClaropaySdk().isCardCustomer(
			this.props.userInfo && 
			this.props.userInfo["claro-profile.person.claroid"] ? 
			this.props.userInfo["claro-profile.person.claroid"] : ""
		);
		this.props.setTokenizationCard({
			open: true,
		});
		console.debug("isCardCustomer", typeof isCardCustomer, JSON.parse(isCardCustomer))
		this.setState({
			showTokenizationCard: true,
			openSelectCardAnonimous: false,
			isCardCustomer: JSON.parse(isCardCustomer)
		});
		this.props.setLoadingTokenizationCard(true);
	};
	closeTokenizationCard = (cardInfo) => {
		this.setState({
			openSelectCardAnonimous: false,
			visibleInputCvv: true,
			valueCvv: cardInfo.cardCvv,
			showTokenizationCard: false,
			tokenizarionResponse: cardInfo,
			updateWithTokenization: undefined,
		});
	}

	validateForTokenizationCard = () => {
		let inputsForValidationArray = this.props.dataConfigInputs.filter(
			(element) => {
				if (element.field) {
					return (
						(element.field.input.value == "" ||	element.field.input.value == undefined) &&
						element.field.input.logicType == undefined &&
						element.constraints &&
						element.id !== "cvv"
					);
				}
			}
		);
		let inputsValidatedArray = this.state.inputsvalidated.filter(element => element !== "isValidCvv");
		const fillFields = inputsForValidationArray.length == inputsValidatedArray.length ? true : false;

		this.addItemValidated("isValidCvv");
		this.setState({
			visibleInputCvv: true,
			valueCvv: this.state.tokenizarionResponse.cardCvv,
			setValueCvv: true,
			cvvWithTokenizationResponse: true,
		 });
		if (!fillFields) {
			if(this.props.isAnonimous){
				this.handleIsOpenCompleteInformationTokenizationSnackBar(true);
			} else {
				this.props.executeTaggeo({
					step: "Formulario de pago",
					action: "View snackbar Tarjeta guardada",
					eventName:"pay_service_or_tae",
					isAnonimous: this.props.isAnonimous,
					service: this.props.tagServiceId
				});
				const url = {
					app: "startEventNoClose",
					to : this.props.isContainerTelcel? "showContainerSnackBar" : this.props.canRegisterEmail? "showContainerSnackBar" : "showGenericSnackBack",
					parameters: JSON.stringify({show: "true",name:"highlightMB",cp:"CP0005",flow:"TokenizationCard",type:"positive"}),
				};
				const snackbarSaveCardSuccessParams = JSON.stringify(url)
				sdkclaro.getInstance().openNative(snackbarSaveCardSuccessParams);
			}
			this.props.handleShowLoaderWaitSubmit(false);
			let exitMap = false;
			inputsForValidationArray.map(input => {
				if (
					input.constraints &&
					input.field &&
					input.field.input &&
					input.field.input.name &&
					input.id !== "cardId" &&
					!exitMap
				) {
					const constraints = typeof input.constraints === "object" && Object.keys(input.constraints).length >= 1
						? input.constraints[0]
						: input.constraints
					const regex = new RegExp(constraints);
					const name = input.field.input.name;
					const inputDom = document.querySelector(`input[name=${name}]`);
					if (inputDom && inputDom.value && !regex.test(inputDom.value)) {
						inputDom.focus();
						exitMap = true;
					}
				}
			});
		} else {
			if(!this.props.isAnonimous){
				const url = {
					app: "startEventNoClose",
					to : this.props.isContainerTelcel? "showContainerSnackBar" : this.props.canRegisterEmail? "showContainerSnackBar" : "showGenericSnackBack",
					parameters: JSON.stringify({show: "true",name:"highlightMB",cp:"CP0005",flow:"TokenizationCard",type:"positive"}),
				};
				const snackbarSaveCardSuccessParams = JSON.stringify(url)
				if(validateUserAgent() === "android"){
					if(this.props.isContainerTelcel || this.props.canRegisterEmail){
						// Remove snackbar because in the new flow of unification it shows duplicated snackbars
						// this.props.setSnackBarSuccess({show: "true",name:"highlightMB",cp:"CP0005",flow:"TokenizationCard",type:"positive"});
					} else {
						// sdkclaro.getInstance().openNative(snackbarSaveCardSuccessParams);
					}
				} else {
					sdkclaro.getInstance().openNative(snackbarSaveCardSuccessParams);
				}
				this.props.executeTaggeo({
					step: "Confirma tu información",
					action: "View snackbar Tarjeta guardada",
					eventName:"pay_service_or_tae",
					isAnonimous: this.props.isAnonimous,
					service: this.props.tagServiceId
				});
			}
			this.setState({
				redirectToAutoSumbit: true,
			});
		}
	}
	handleInputClick = (event, typeInput, cardInfo, value, productId) => {
		const {
			setCreditCardInfo, isContainerTelcel, isAnonimous, isUnificationFlow,
			serviceId, tagServiceId, userInfo
		} = this.props
		console.debug(typeInput, cardInfo, this.props, "HANDLESS ")
		if (typeInput == "cardId") {
			this.props.setSnackBarSuccess(undefined);
			setCreditCardInfo(cardInfo);				
			this.setState({ 
				openSelectCardClaroSocio: false, 
				setValueCvv: false, 
				openSelectCardAnonimous: false , 
				showBannerTapToApp: true
			});
			if (cardInfo.value == "agregar-targeta") {
				this.setState({
					valueSelectInput: "",
					mark: "",
					valueCardId: "",
					updateWithTokenization: undefined,
				});
				console.debug("openWallet_______2 ya");
				console.debug(this.props.tokenizationOn)
				if(this.props.tokenizationOn){
					this.setAddCardFormDataHandler();
				} else {
					if(isUnificationFlow){
						this.setAddCardFormDataHandler();
					} else {
						sdkclaro.getInstance().openWallet("openWallet");
					}
				}
				this.deleteItemValidated("isValidCardId");
			} else {
				if (cardInfo.update == true) {
					this.setState({
						openModalUpdateCard: true,
						valueSelectInput: "",
						mark: "",
						valueCardId: cardInfo.value,
						cvvWithTokenizationResponse: false,
						updateWithTokenization: cardInfo.card,
					});
				} else {
					this.setState({
						valueSelectInput: cardInfo.lastDigits,
						valueCardId: cardInfo.value,
						mark: cardInfo.mark,
						cvvWithTokenizationResponse: false,
						updateWithTokenization: undefined,
					});

					let valueToCommissions = this.context.ocrAmountValue;
					let _item_amount = _.find(this.props.dataConfigInputs, [
						"id",
						"amount",
					]);
					if (_item_amount) {
						if (
							_item_amount.field.input.value &&
							_item_amount.field.input.value != ""
						) {
							valueToCommissions = _item_amount.field.input.value;
						}
					}

					if (this.props.amountPlan) {
						valueToCommissions = this.props.amountPlan;
					}
					if (this.props.selectedChipValues && !this.props.amountPlan) {
						valueToCommissions = this.props.selectedChipValues.amountValue;
					}

					if (this.props.selectedPlan && Object.keys(this.props.selectedPlan).length > 0) {
						valueToCommissions = this.props.selectedPlan.cost
					}

					this.getCommissions(cardInfo.value, String(valueToCommissions));
					this.addItemValidated("isValidCardId");
					if (cardInfo.value == CREDIT_CLARO_PAY || cardInfo.value === ADVANCEMENT_CLARO_PAY) {
						setTimeout(() => {
							this.addItemValidated("isValidCvv");
							this.setState({ visibleInputCvv: false });
						}, 500);
					
					}
          succedFeaturedDatadog(
						PAGO_SERVICIOS_PAY_METHOD, 
						userInfo.fullstoryIdOperationKey, 
						serviceId, 
						'Selección método de pago exitosa'
					);        
				}
			}
		}

		if (typeInput == "select-chips") {
			if (this.props.isContainerTelcel && this.props.serviceId === SERVICE_ID_TELCEL_RECARGA) {
				this.props.handleGetSelectPlanByCost(this.props.plans, value);
			} else {
				this.getCommissions(this.state.valueCardId, String(value));
				this.setState({ valuetChipInput: value, valueChipProductId: productId });
				window.valuetChipInput = value
				this.props.setSelectedChipValues(productId, value);
				this.context.getAmountFromOcrData(value);
				this.addItemValidated("isValidAmount");
			}

			if(!this.props.isContainerTelcel && this.props.serviceId === SERVICE_ID_TELCEL_RECARGA){
				this.handleSetAdvancementPayMethod(value);
			}
		}

		if (typeInput == "setFocusFieldAmount") {
			document
				.getElementById("pagoDeServicios_amount_" + this.props.serviceName)
				.focus();
			this.taggeo("Click Editar monto");
		}

		if (typeInput == "setAmountTelcelPostago") {
			this.taggeo("Click Consultar saldo");
			this.setStepTrack("CS01");
			if (this.state.destAccountIdValue.length == 10) {
				this.props.getAmountOfTelcelPospago(
					this.state.destAccountIdValue,
					this.props.serviceId
				);
				this.setState({ setAmountTelcelPospago: true });
			}
		}

		if (typeInput == "getAmountArcusBillers") {
			if (!this.state.isDisabledButtonArcusGetAmount) {
				this.taggeoArcus("Click Consultar saldo")

				const item = this.props.dataConfigInputs.find(element => element.distpatchGetAmount);

				if (item) {
					const distpatchGetAmountLength = item.distpatchGetAmountLength;
					const referenceLength = this.state.destAccountIdValue.length;
					
					if (distpatchGetAmountLength && distpatchGetAmountLength === referenceLength) {
						this.props.getAmountOfTelcelPospago(
							this.state.destAccountIdValue,
							this.props.serviceId
						);
						this.setState({ setAmountTelcelPospago: true });
					}
				}				
			}			
		}

		if (typeInput == "tapToApp") {			
 			this.addItemValidated("isValidCvv");
			this.setState({
			 	openSelectCardClaroSocio: false, 
				valueSelectInput: cardInfo.text,
				mark: cardInfo.mark,
				tapToapp: true,
				visibleInputCvv: false, 
				valueCardId: cardInfo.value,
				cvvWithTokenizationResponse: false,
				updateWithTokenization: undefined,
				showBannerTapToApp: false,
			});
			// this.setAddCardFormDataHandler();
		}
	};
	isButtonSubmitDisabled() {
			let inputsForValidationArray = this.props.dataConfigInputs.filter(
			(element) => {
				if (element.field) {
					if (this.props.sdkVersion !== undefined) {
						return (
							(element.field.input.value == "" ||
								element.field.input.value == undefined) &&
							element.field.input.logicType == undefined &&
							element.constraints
						);
					} else {
						return (
							(element.field.input.value == "" ||
								element.field.input.value == undefined) &&
							element.constraints &&
							element.id != "cardId" &&
							element.id != "cvv"
						);
					}
				}
			}
		);
		if(this.props.serviceId === SERVICE_ID_TELCEL_POSPAGO){
		        if(this.state.inputsvalidated.includes('isValidContacts') && this.state.inputsvalidated.includes('isValidOcr')  && this.props.contactNumber){
                    this.deleteItemValidated('isValidOcr')	
				}else if(!this.props.contactNumber && this.state.destAccountIdValue.length<10 && this.state.inputsvalidated.includes('isValidContacts')){
					this.deleteItemValidated('isValidContacts')
				}
			}
		let inputsValidated = this.state.inputsvalidated.length;
		let inputsForValidation = inputsForValidationArray.length;
		if (inputsForValidation == inputsValidated) {
			this.setState({ buttonState: { disabled: false } });
		} else {
			this.setState({ buttonState: { disabled: true } });
		}
	}

	handleInputButtonFunction = (event, type) => {
		const { isAnonimous } = this.state;
		const { serviceId, tagServiceId, userInfo } = this.props;
		switch (type) {
			case "contacts":
				this.setStepTrack("V1-CONTACTS-TFR-P2P");
				this.taggeo("Click Agenda");
				break;
			case "ocr":
				this.setStepTrack("V1-SCAN-QR-TFR-P2P");
				let _item = _.find(this.props.dataConfigInputs, [
					"id",
					"destAccountId",
				]);
				this.setState({
					setFromOcrScannerData: true,
					_item: _item,
					setDefaultOcrValue: false,
				});
				if(this.props.canMultiAnalytics && this.props.isContainerTelcel) {
					const originAnalyticArray = this.props.originAnalytic? this.props.originAnalytic.split(",") : [];
					this.props.executeTaggeo({
							eventName: "pay_service_or_tae",
							seccion: "servicios",
							subseccion: this.props && this.props.serviceId && getServicesTelcel(this.props.serviceId),
							origen: originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services",
							pantalla: "formulario de pago",
							nombreServicio: this.props && this.props.serviceName,
							tipoElemento: "boton",
          		nombreElemento: "escanear",
							trackAction: true,
					}, true);
    		}  
				startFeaturedDatadog(
					PAGO_SERVICIOS_SCANNER, 
					userInfo.fullstoryIdOperationKey, 
					serviceId, 
					'Inicio escáner'
				);
				this.props.getOCRScanner(
					this.props.isClaroPartner,
					this.props.imgTooltip,
					_item.field.input.maxlength,
					_item.format,
					_item.regexAndroid,
					_item.regexIos,
					_item.aspectratio,
					_item.orientation
				);
				this.context.handleSetAmountFromInput(false);
				break;
			case "select":
				startFeaturedDatadog(
					PAGO_SERVICIOS_PAY_METHOD, 
					userInfo.fullstoryIdOperationKey, 
					serviceId, 
					'Inicio selección método de pago/default'
				);
				if(this.props.canMultiAnalytics && this.props.isContainerTelcel) {
					const originAnalyticArray = this.props.originAnalytic? this.props.originAnalytic.split(",") : [];
					this.props.executeTaggeo({
							eventName: "pay_service_or_tae",
							seccion: "servicios",
							subseccion: this.props.serviceInfo && this.props.serviceInfo.serviceId && getServicesTelcel(this.props.serviceInfo.serviceId),
							origen: originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services",
							pantalla: "formulario de pago",
							nombreServicio: this.props && this.props.serviceName ,
							tipoElemento: "boton",
          					nombreElemento: "metodo de pago",
							trackAction: true,
							isTelcel: true,
					}, true);
    		} else {
					this.taggeo("Click Método de pago");
				}
				this.setState({ setDefaultSelectValue: false });
				!isAnonimous ? this.getSelectPayment() : this.getSelectPaymentAnonimous();
				break;
		}
	};

	getSelectPayment = (event) => {
		const { getPaymentMethods, serviceId, isClaroPartner } = this.props;
		getPaymentMethods(serviceId, isClaroPartner);
		this.setState({ openSelectCardClaroSocio: true });
		this.setStepTrack("COMP01");
	};

	getSelectPaymentAnonimous = (event) => {

		if(this.props.isAnonimous && this.props.canR1Flag && this.props.canR1 == null){
			// show alert
			this.setState({
				modalMessaging:{
					show:true,
					flux: "FlujoAnonimo",
					code: "CP0006"
				}
			})
		} else {
			this.setState({ openSelectCardAnonimous: true });
		}
	};

	handleClickTooltip = (event, type) => {
		let dataConf = this.props.dataConfigInputs.find(config => config.id === 'buttonBox');
    let favOps = dataConf ? dataConf.cp.find(input => input.id === 'favoritos') : null;
		
		let textTitleTooltip = "";
		let imgTooltip = "";
		let heightTooltip = "";
		let heightImg = "";
		let fontSizeTitleTooltip = "";
		let fontColorTooltip = "";
		let textSubtitle = "";
		let imgTooltipPosition = (this.props.imgTooltipPosition && this.props.imgTooltipPosition !== "") ? this.props.imgTooltipPosition : null;
		let imgTooltipWidth = (this.props.imgTooltipWidth && this.props.imgTooltipWidth !== "") ? this.props.imgTooltipWidth : '272px';

		switch (type) {
			case "ocr":
				if (this.props.isClaroPartner) {
					textTitleTooltip = <Text_CS_TooltipTitle />;
				}else if (this.props.canManageFavorites && favOps && !!favOps.textTitleTooltipFavoritos && !this.props.isContainerTelcel) {
					textTitleTooltip= favOps.textTitleTooltipFavoritos;
					imgTooltipPosition = favOps.imgTooltipPositionFav;
					imgTooltipWidth = favOps.imgTooltipWidthFav;
				} else {
					textTitleTooltip =
						this.props.textTitleTooltip &&
							this.props.textTitleTooltip.length > 0
							? this.props.textTitleTooltip
							: "En el siguiente ejemplo encontraras los datos necesarios para pagar tu servicio.";
				}
				imgTooltip = this.props.canManageFavorites && favOps && !!favOps.imgTooltipFavoritos && !this.props.isContainerTelcel && !this.props.isClaroPartner ? favOps.imgTooltipFavoritos : this.props.imgTooltip;
				heightTooltip = "85%";
				heightImg = validateUserAgent() === "android" ? "75%" : "70%";
				fontSizeTitleTooltip = "13px";
				fontColorTooltip = "#B2B2B2";
				textSubtitle = "";
				break;
			case "cvv":
				textTitleTooltip = "Tarjeta Visa y Master Card";
				imgTooltip = this.props.isContainerTelcel ? "/images/cvv.png" : "/images/cvv.svg";
				heightTooltip = "58%";
				heightImg = validateUserAgent() === "android" ? "43%" : "38%";
				fontSizeTitleTooltip = this.props.isContainerTelcel ? "18px" : "15px";
				fontColorTooltip = this.props.isContainerTelcel ? "#000000" : "#161616";
				textSubtitle =
					"El número de tres dígitos ubicado en el reverso de tu tarjeta de crédito o débito.";
				break;
		}

		this.setState({
			addCloseEfect: false,
			openToolTip: true,
			textTitleTooltip: textTitleTooltip,
			imgTooltip: imgTooltip,
			imgTooltipPosition: imgTooltipPosition,
			imgTooltipWidth: imgTooltipWidth,
			heightTooltip: (this.props.tooltipHeight && this.props.tooltipHeight !== "") ? this.props.tooltipHeight : heightTooltip,
			heightImg: heightImg,

			fontSizeTitleTooltip: (
				this.props.textTitleTooltipFontSize &&
				this.props.textTitleTooltipFontSize !== ""
			)
				? this.props.textTitleTooltipFontSize
				: fontSizeTitleTooltip,

			fontColorTooltip: (
				this.props.textTitleTooltipFontColor &&
				this.props.textTitleTooltipFontColor !== ""
			)
				? this.props.textTitleTooltipFontColor
				: fontColorTooltip,

			marginTitleTooltip: (
				this.props.textTitleTooltipMargin &&
				this.props.textTitleTooltipMargin !== ""
			)
				? this.props.textTitleTooltipMargin
				: null,

			textSubtitle: textSubtitle,
		});
	};

	onclickCloseTooltip = () => {
		this.setState({ addCloseEfect: true });
		setTimeout(
			function () {
				this.setState({ openToolTip: false });
			}.bind(this),
			900
		);
	};

	onclickModalNoPendingAmount = () => {
		this.taggeoArcusSaldoCero("Click Entendido", "Saldo cero");
		this.setState({
			openAlertNoPendingAmount: false,
			titleModalTelcel: "",
			subtitleModalTelcel: "",
			buttonTextTelcel: "Entendido",
		});
	}

	closeSelectCardClaroSocio = () => {
    const { serviceId, tagServiceId, userInfo } = this.props;
		failedFeaturedDatadog(
			PAGO_SERVICIOS_PAY_METHOD, 
			userInfo.fullstoryIdOperationKey, 
			serviceId,
			'Salio en selección método de pago',
			'abandoned'
		);
        
		this.setState({ openSelectCardClaroSocio: false });
	};


	onclickUpdateCard = (event) => {
		this.setState({ openModalUpdateCard: false });
		if (event.target.textContent == "Actualizar ahora") {
			console.debug("openWallet_______3 ya");
			console.debug(this.props.tokenizationOn);
			if(this.props.tokenizationOn){
				this.setAddCardFormDataHandler();
			} else {
				sdkclaro.getInstance().openWallet("openWallet-" + this.state.updateWithTokenization.cardId);
			}
		}
	};

	btn1Action = () => {
		this.modalValidationNumberAPTaggeo(
			'Click No',
			this.state.modalValidationNumberAPCase
		);

		this.setState({
			modalValidationNumberAPIsOpen: false
		});

		if (this.state.modalValidationNumberAPCase === 1) {
			if (this.state.itemDistpatchGetAmount) {
				this.props.getAmountOfTelcelPospago(
					this.state.destAccountIdValue,
					this.props.serviceId
				);
				this.setState({ setAmountTelcelPospago: true });
				this.setStepTrack("CS01");
			}
		}

		if (this.state.modalValidationNumberAPCase === 2) {
			this.setState({ destAccountIdValue: '' })
			//document.getElementById("pagoDeServicios_destAccountId_" + this.props.serviceName.trim()).focus();
		}
	}

	btn2Action = () => {
		this.modalValidationNumberAPTaggeo(
			'Click Si',
			this.state.modalValidationNumberAPCase
		);

		// Open microapp
		let microAppId = "";
		switch (this.state.modalValidationNumberAPCase) {
			case 1:
				microAppId = "amigopaguitos"
				break;

			case 2:
				microAppId = "TelcelPospagoPS"
				break;

			default:
				break;
		}

		const url = {
			app: "startEventNoClose",
			to: "openMicroApp",
			parameters: JSON.stringify({
				microAppId: microAppId,
				skipLobby: (this.state.modalValidationNumberAPCase === 2) ? false : true
			}),
		}

		setTimeout(() => {
			sdkclaro.getInstance().openNative(
				JSON.stringify(url),
				() => { },
				() => { },
			)
		}, 1000);

		this.setState({
			modalValidationNumberAPIsOpen: false,
		});
	}

	submitFormToPayTopic = () => {
		const {
			destAccountIdValue,
			valueCardId,
			valueChipProductId,
			valueCvv,
			valueDescription,
			responseCode,
			responseCodeMessage,
			discount,
			discountCredit,
			inquiryTelmexId,
			dataConfigInputs
		} = this.state;

		const { 
			originOfPayment, serviceId, paramsNewOfferTelcel, serviceInfo,
			tagServiceId, destAccountIdType, feeAmount, serviceName, configImgService,
			trackId, sdkVersion, contactInfo, contactsList, paymentMethods, userInfo,
			amountPlan, urlFlags
		} = this.props;
		let { selectedPlan, planCategory } = this.props;

		let item = {};
		let categoryId = 
				serviceInfo.categoryPlansId == undefined
				? ""
				: serviceInfo.categoryPlansId;
		let paymentMethodIsCredit = valueCardId == CREDIT_CLARO_PAY || valueCardId == ADVANCEMENT_CLARO_PAY;
		// Datos para upsell, banners y beneficios telcel
		let plansForUpsell = [];
		this.props.plansForUpsell.map((plan, index) => {
			const productId = serviceId === SERVICE_ID_TELCEL_RECARGA 
				? plan.idExternal 
				: calculateProductId(null, plan.cost, planCategory, plan.idExternal);

			plansForUpsell[index] = {
				id: plan.id,
				productId: productId,
				cost: plan.cost,
				label: plan.label,
				amount: plan.amount,
				mb: plan.mb,
				promotions: {
					PromotionMegasGift: plan.promotions && plan.promotions.PromotionMegasGift 
						? plan.promotions.PromotionMegasGift 
						: null,
					PromotionAccountN2Change: plan.promotions && plan.promotions.PromotionAccountN2Change 
						? plan.promotions.PromotionAccountN2Change 
						: null,
				}
			}
		});

		if (selectedPlan && Object.keys(selectedPlan).length > 0) {
			const productId = serviceId === SERVICE_ID_TELCEL_RECARGA 
				? selectedPlan.idExternal 
				: calculateProductId(null, selectedPlan.cost, planCategory, selectedPlan.idExternal);

			selectedPlan = {
				id: selectedPlan.id,
				productId: productId,
				cost: selectedPlan.cost,
				label: selectedPlan.label,
				amount: selectedPlan.amount,
				mb: selectedPlan.mb,
				promotions: {
					PromotionMegasGift: selectedPlan.promotions && selectedPlan.promotions.PromotionMegasGift 
						? selectedPlan.promotions.PromotionMegasGift 
						: null, 
					PromotionAccountN2Change: selectedPlan.promotions && selectedPlan.promotions.PromotionAccountN2Change 
						? selectedPlan.promotions.PromotionAccountN2Change 
						: null,
				}
			}
		}		

		let cvv = "";
		if (this.state.isAnonimous) {
			cvv = this.props.cvvForAnonimous
		} else {
			let cvvValueAutomatic = "";
			if(paramsNewOfferTelcel && paramsNewOfferTelcel.cvv && paramsNewOfferTelcel.cvv.cvvValue){
				cvvValueAutomatic = paramsNewOfferTelcel.cvv.cvvValue;
			}
			cvv = paymentMethodIsCredit ? "" : valueCvv ? valueCvv : cvvValueAutomatic;
		}	

		item[`highlightMegasTelcel`] = {
			megasGiftImageUrl: this.state.megasGiftImageUrl,
			plansForUpsell: plansForUpsell,
			selectedPlan: selectedPlan,
		}
		//
		item[`destAccountIdType`] = this.props.destAccountIdType;
		item[`serviceId`] = this.props.serviceId;
		item["serviceName"] = this.props.serviceName;
		item[`feeAmount`] = this.props.feeAmount;
		item[`logo`] =  this.props.configImgService;
		item[`category`] = "MF";
		item[`amount`] = parseFloat(this.context.ocrAmountValue.replace(/,/g, ""));
		item[`productId`] = valueChipProductId;
		item["description"] = valueDescription;
		item["destAccountId"] = destAccountIdValue.replace(/\s+/g, "");
		item["responseCodeMessage"] = responseCodeMessage;
		item["responseCode"] = responseCode;
		item["categoryId"] = categoryId;
		item["transactionId"] = trackId ? trackId : "";
		item["tagServiceId"] = tagServiceId
			? tagServiceId
			: "";
		if (sdkVersion) {
			item["payProcessor"] = paymentMethodIsCredit
				? {}
				: this.props.commissionRules[0].payProcessor;
			item["discount"] = paymentMethodIsCredit ? discountCredit : discount;
			item["cvv"] = cvv;
			item["totalCommission"] = paymentMethodIsCredit
				? 0
				: this.props.commissionRules[0].totalCommission;
			item["cardId"] = valueCardId;

			if (this.props.isClaroPartner) {
				item["commissionAmountService"] = paymentMethodIsCredit
					? 0
					: this.props.commissionRules[0].commissionByService;
				item["commissionAmountPayMethod"] = paymentMethodIsCredit
					? 0
					: this.props.commissionRules[0].totalPayMethod;
			}
		}
		if (serviceInfo.serviceId === TELMEX) {
			item["inquiryTelmexId"] = inquiryTelmexId;
		}

		const dataContact = contactInfo;
		const contacts = Object.values(contactsList);
		if (
			contactInfo &&
			dataContact.length != 0 &&
			contacts.lengh != 0
		) {
			let contactRecentIsContact = contacts.filter(
				(contact) => contact.displayName == dataContact.fullName
			);
			if (contactRecentIsContact.length > 0) {
				this.props.addContactToRecents(dataContact, serviceId);
			}
		}

		// Provicional para sears

		if (serviceId == 245) {
			const { infoPlanSears, noInternet, searsCardNumber, paymentCard } = this.props;
			const { sequence, paymentNumber } = infoPlanSears;
			item["destAccountId"] = searsCardNumber;
			item["inquiryTelmexId"] = null;
			// item["inquiryTelmexId"] = `${noInternet}|${floatToInteger(
			//   paymentNumber
			// )}|${floatToInteger(sequence)}`;
			item["paymentCard"] = paymentCard;
		}

		const { multipleServiceIds } = this.props;

		if (multipleServiceIds) {
			if (destAccountIdValue.length == multipleServiceIds.ocr.referenceLength) {
				item[`serviceId`] = multipleServiceIds.ocr.serviceId;
			}
			if (
				destAccountIdValue.length == multipleServiceIds.manual.referenceLength
			) {
				item[`serviceId`] = multipleServiceIds.manual.serviceId;
			}
		}

		if (valueCardId != "") {
			let itemCardInfo = paymentMethods.cardList.filter(function (
				item
			) {
				return item.cardId === valueCardId;
			});
			item["cardInfo"] = itemCardInfo[0];
			if (valueCardId == "claro-pay") {
				item["cardInfo"] = { cardId: "claro-pay" };
			}
			if (valueCardId == CREDIT_CLARO_PAY) {
				item["cardInfo"] = { cardId: CREDIT_CLARO_PAY };
			}
			if (valueCardId == ADVANCEMENT_CLARO_PAY) {
				item["cardInfo"] = { cardId: ADVANCEMENT_CLARO_PAY };
			}
		}

		if (serviceInfo.logicType == "claroVideo") {
			item[`productId`] = serviceInfo.productId;
			item["destAccountId"] = userInfo.msisdn.slice(3, 13);
			item["description"] = "Compra Claro Video 1 Mes";
		}

		item[`originOfPayment`] = originOfPayment ? originOfPayment : "Home";
		item[`methodPaymentAnalytic`] = this.props.addCardFormData ? this.props.addCardFormData.paymentMethod : "tdc";
		// Valida si la referencia enviada al pago esta dentro de favoritos o guardados de este usuario para este servicio,
		// si no es asi, manda showFavorites= true para que nativo presenta la invitacion a guardar como favorito.
		const {listFavServices, listReminder } = this.props
		item['showFavorites'] = findReference(
			listFavServices, listReminder, destAccountIdValue, dataConfigInputs
		)

		item['originAppIdPayment'] = tagServiceId
		if(tagServiceId === "serviciopagotelcelMenu" && serviceId === SERVICE_ID_TELCEL_POSPAGO ){
			item['originAppIdPayment'] = paramsNewOfferTelcel ? tagServiceId : TELCEL_POSPAGO_MICROAPP_ID
			item['hasN2'] = paymentMethods ? paymentMethods.hasN2 : ""
			item['hasNIP'] = paymentMethods ? paymentMethods.hasNIP : ""
		}

		if (
			paramsNewOfferTelcel &&
			(serviceId === SERVICE_ID_TELCEL_PLANES) &&
			paymentMethods.hasAdvancement &&
			userInfo &&
			userInfo.advancePayment &&
			userInfo.advancePayment.creditAmount &&
			amountPlan <= userInfo.advancePayment.creditAmount &&
			this.state.valueCardId !== ADVANCEMENT_CLARO_PAY
		) {
			item['advancementSnackbar'] = {
				show: true,
				service: this.props.tagServiceId
			}
		}
		item['dataDomiciliation'] = buttonDomiciliationConfigExist(dataConfigInputs) && this.props.hasDmResponse.data || {}
		
		localStorage.setItem("microappInfo", JSON.stringify({
			serviceId: serviceId,
			paramsNewOfferTelcel: paramsNewOfferTelcel,
			categoryPlansId: serviceInfo.categoryPlansId
		}));
		console.log(JSON.stringify(item), "ENVIADO AL FORM");
		if(this.props.canMultiAnalytics && this.props.isContainerTelcel) {
			const originAnalyticArray = this.props.originAnalytic? this.props.originAnalytic.split(",") : [];
			if(this.props.serviceName && this.props.serviceName.toUpperCase() === "AMIGO PAGUITOS"){
				this.props.executeTaggeo({
					eventName: "pay_service_or_tae",
					seccion: "servicios",
					subseccion: serviceId && getServicesTelcel(serviceId),
					origen: originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services",
					pantalla: "formulario de pago",
					nombreServicio: this.props.serviceName,
					operacion_nombre: "amigo paguitos",
					operacion_tipoRespuesta: "exito",
					operacion_variante: "consulta",
					operacion_Exito_se: "1",
					tipoElemento: "boton",
					nombreElemento: "pagar",
					referencia: item.destAccountId,
					payment_method: this.props.addCardFormData && this.props.addCardFormData.paymentMethod ?
					this.getMethodPayment(this.props.addCardFormData.paymentMethod) 
					:
					this.props.creditCardInfo && this.props.creditCardInfo.value === "claro-pay"?
						"cuenta n2"
						:
						this.props.creditCardInfo.type === "2"? "tdc" : "tdd",
					concept: item.description,
					cantidad: item.amount,
					trackAction: true,
					isTelcel: true,
				}, true);
			} else {
				this.props.executeTaggeo({
					eventName: "pay_service_or_tae",
					seccion: "servicios",
					subseccion: serviceId && getServicesTelcel(serviceId),
					origen: originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services",
					pantalla: "formulario de pago",
					nombreServicio: this.props.serviceName,
					tipoElemento: "boton",
      				nombreElemento: "continuar",
					referencia: item.destAccountId ? item.destAccountId : this.props.userInfo && this.props.userInfo.msisdn && this.props.userInfo.msisdn,
					payment_method: this.props.creditCardInfo ? this.getMethodPaymentWithMarkAndType(this.props.creditCardInfo) : "tdc",
					concept: "pago credito",
					cantidad: item.amount,
					trackAction: true,
				}, true);
			}
    }
		if (urlFlags.includes("CAN_FULLSTORY")) {
			succedFeaturedDatadog(
				PAGO_SERVICIOS_FORM_LOAD, 
				userInfo.fullstoryIdOperationKey, 
				this.props.serviceId, 
				'Click continuar',
			)
		}
    
		this.props.setPaymentServiceData(item);
		setTimeout(() => {
			this.props.handleShowLoaderWaitSubmit(false);
		}, 2000);
		setTimeout(
			function () {
				this.setState({ buttonState: { disabled: false } });
			}.bind(this),
			500
		);
	};

	getMethodPayment = (paymentMethod) => {
		let paymentMethodString = "tdc";
		if(paymentMethod === "credit") {
			paymentMethodString = "tdc";
		} else if(paymentMethod === "debit") {
			paymentMethodString = "tdd";
		} else {
			paymentMethodString = "cuenta n2";
		}
		return paymentMethodString;
	}

	getMethodPaymentWithMarkAndType = (creditCardInfo) => {
		let markString = "tdc";
		if(creditCardInfo.mark === "999") {
			markString = "cuenta n2";
		} else if(creditCardInfo.mark === "1") {
			markString = "tdc";
		} else {
			markString = "tdd";
		}

		return markString;
	}

	handleSubmit = () => {

		console.log("handleSubmit", this.props, this.state);
		let { ocrAmountValue } = this.context;
		let { valueCardId } = this.state;
		const { verifyNfcState } = this.props;
		if(!this.state.tapToapp){
			this.setState({ buttonState: { disabled: true }, submitClicled: true });
		}
		let currentAmount = ocrAmountValue.replace(/,/g, "");
		if (
			parseFloat(currentAmount) < AMOUNT_MIN_TO_USE_CREDIT &&
			valueCardId === CREDIT_CLARO_PAY
		) {
			this.setState({ amountMinAlert: true });
			this.deleteItemValidated("isValidAmount");
		} else {
			if (this.state.tapToapp){
				this.props.executeTaggeo({
					eventName: "pay_service_or_tae",
					claro_id: this.props.userInfo && this.props.userInfo["claro-profile.person.claroid"],
					msisdn: this.props.userInfo && 
						this.props.userInfo.msisdnEncrypt && 
						this.props.userInfo.msisdnEncrypt.data,
					step: "Formulario de pago",
					action: "Click continuar",
					service_id: this.props.serviceInfo.serviceId,
					product_id: this.state.valueChipProductId,
					service_reference: this.state.contactsValue,
					payment_method: "Pagar sin contacto",
				});	
				const url = {
					app: "startEventNoClose",
					to: "tapToApp",
					parameters: {id: "verifyOnNFC"},
				};
				const verifyNFC = JSON.stringify(url)
				sdkclaro.getInstance().openNative(
						verifyNFC,               
						(data) => {
							console.log("Success NFC", data);	
						},
						(err) => {
							console.log(err, "error nfc")
						}
				)
				if(!verifyNfcState){
					this.props.executeTaggeo({
						eventName: "pay_service_or_tae",
						claro_id: this.props.userInfo && this.props.userInfo["claro-profile.person.claroid"],
						msisdn: this.props.userInfo && 
							this.props.userInfo.msisdnEncrypt && 
							this.props.userInfo.msisdnEncrypt.data,
						step: "Formulario de pago",
						action: "View alert",
						alert_id: "Enciende tu NFC",
						service_id: this.props.serviceInfo.serviceId,
						product_id: this.props.productIdFromPlan,
					});	
				}
			} else {
				this.setState({ submitClicled: false });
				this.submitFormToPayTopic();
			     this.taggeo("Click Continuar")
			}
		}
	};

	openSettingsNFC = () => {
		const { setVerifyNfc, verifyNfcState, executeTaggeo } = this.props;
		const url = {
			app: "startEventNoClose",
			to : "openSettings",
			parameters: {id: "nfc"},
		};
		executeTaggeo({
			eventName: "pay_service_or_tae",
			claro_id: this.props.userInfo && this.props.userInfo["claro-profile.person.claroid"],
			msisdn: this.props.userInfo && 
				this.props.userInfo.msisdnEncrypt && 
				this.props.userInfo.msisdnEncrypt.data,
			step: "Formulario de pago",
			action: "Click alert Ir a configuración",
			alert_id: "Enciende tu NFC",
			service_id: this.props.serviceInfo.serviceId,
			product_id: this.props.productIdFromPlan,
		});
		if(this.state.openNFCSettings){
			this.setState({openNFCSettings: false})
			setVerifyNfc(false)
		}
		const verifyNFC = JSON.stringify(url)
		sdkclaro.getInstance().openNative(
			verifyNFC,               
			(data) => {
				console.log("Success NFC Settings", data);	
			},
			(err) => {
				console.log(err, "error nfc")
			}
		)
	}

	onCloseModalNFCSettings = () => {	
		const { setVerifyNfc } = this.props;
		this.setState({ openNFCSettings: false })
		setVerifyNfc(false)
	}

	handleModalClaroOk = (event) => {
		this.setState({
			openModalTelcel: false,
			titleModalTelcel: "",
			subtitleModalTelcel: "",
			buttonTextTelcel: "",
		});
		switch (event.target.textContent) {
			case "Reintentar":
				setTimeout(() => {
					this.props.getAmountOfTelcelPospago(
						this.state.destAccountIdValue,
						this.props.serviceId
					);
					this.setStepTrack("CS01");
					this.setState({setAmountTelcelPospago: true})
				}, 800);
				break;
			case "Pagar otra cantidad":
				document.getElementById("pagoDeServicios_amount_" + this.props.serviceName).focus();
				break;
			case "Modificar número":
				document.getElementById("pagoDeServicios_destAccountId_" + this.props.serviceName.trim()).focus()
				break;
			case "Ok":
				sdkclaro.getInstance().closeMicroFront();
				break;
			default:
		}
	}

	getImgTypeMessage = (messageType) => {
		switch (messageType) {
			case 0:
				return "data:image/png;base64,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";
			case 1:
				return "data:image/png;base64,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";
			case 2:
				return "data:image/png;base64,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";
			default:
				return "data:image/png;base64,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";
		}
	};

	handleSelectPaymentMethodAnonimous = (value) => {
		this.setState({valuePaymentMethodSelectedAnonimous: value});
	}

	handleSetIsOpenAddCardForm = (value) => {
		this.setState({ isOpenAddCardForm: value})
	}

	handleSetFavValue = (value) => {
		this.setState({
			contactsValue: value,
			destAccountIdValue: value,
			setDefaultOcrValue: false,
			fromListFavorites: true
		})
	}

	render() {
		const button = {
			align: {
				center: true,
			},
			weight: {
				bold: true,
			},
			style: {
				normal: true,
			},
		};


		const {
			ocrScannerData,
			isLoadingCommisSionRules,
			commissionRules,
			serviceInfo,
			paramsNewOfferTelcel,
			isContainerTelcel,
			history,
			buttonContinueLoading,
			serviceId,			
			selectNextPlan,
			creditCardInfo,
			selectedPlan,
			dataConfigInputs,
			appSyncValues,
			messages,
			messagesTokenization,
			paymentMethods,
			tagServiceId,
			tapToappFlag,
			tapToAppParams,
			userInfo,
			isUnificationFlow
		} = this.props;
		const {
			setFromOcrScannerData,
			_item,
			valueCardId,
			scanErrorDestAccountIdValue,
			setCommissionRules,
			marginButtonContinue,
			setAutomaticOnclick,
			openModalComissionError,
			showBannerTapToApp,
			checkBalanceArcusModalContainerIsVisible,
			typeModalContainerChekBalance,
			isAnonimous,
			cvvWithTokenizationResponse,
			destAccountInput
		} = this.state;
        
		setTimeout(() => {
			if (!isLoadingCommisSionRules && commissionRules && setCommissionRules) {
				if (commissionRules[0].cvv == false || this.state.isAnonimous) {
					// Se comenta la lógica de mostrar o no el input del cvv por la tarea de unificacion
					// this.setState({ valueCvv: "" });
					console.log("validation Cvv")
					this.addItemValidated("isValidCvv");
				} else {
					if (
						this.state.inputsvalidated.includes("isValidCvv") &&
						this.state.setValueCvv == false
						&& !this.state.cvvWithTokenizationResponse 
					) {
						// Se comenta la lógica de mostrar o no el input del cvv por la tarea de unificacion
						// this.setState({ valueCvv: "" });
						console.log("validation Cvv")
						this.deleteItemValidated("isValidCvv");
					}
				}
				console.warn("setState en comissionData",commissionRules);
				this.setState({
					// Se comenta la lógica de mostrar o no el input del cvv por la tarea de unificacion
					// visibleInputCvv: !this.state.isAnonimous && !this.state.cvvWithTokenizationResponse ? commissionRules[0].cvv : false,
					visibleInputCvv: getCvvWithTokenizationResponse(isAnonimous, cvvWithTokenizationResponse, isUnificationFlow, commissionRules),
					setCommissionRules: false,
					commissionData: commissionRules,
					discount: commissionRules[0].discountArray,
					totalCommission: commissionRules[0].totalCommission,
				});
			}
			if (this.buttonSubmitRef.current) {
				if (
					(paramsNewOfferTelcel && setAutomaticOnclick) &&
					(
						serviceInfo.categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE ||
						this.props.serviceId === SERVICE_ID_TELCEL_POSPAGO || 
						(
							serviceId === SERVICE_ID_TELCEL_PAQUETES_POSPAGO &&
							serviceInfo.categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_MAS_DATOS
						) ||
						(
							serviceId === SERVICE_ID_TELCEL_PAQUETES_MIXTOS &&
							serviceInfo.categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_MAS_DATOS_MIXTO
						)
					) &&
					!isLoadingCommisSionRules
				) {
					this.setState({ setAutomaticOnclick: false })
					this.buttonSubmitRef.current.click()
				}
			}
		}, 150);

		// Validación para escaner
		const { ocrAmountValue, getAmountFromOcrData, setAmountFromInput } =
			this.context;

		let ocrValue = this.props.isClaroPartner
			? ocrScannerData.code
			: ocrScannerData.data;

		if (JSON.stringify(ocrScannerData) != "{}" && setFromOcrScannerData) {
			// Funcionalidad para sacar referencia del codigo de barras
			if (_item.referenceSubstr && _item.referenceSubstr.length == 2) {
				ocrValue = ocrValue.substring(
					_item.referenceSubstr[0],
					_item.referenceSubstr[1]
				);
			}
			if (ocrValue != scanErrorDestAccountIdValue) {
				this.setState({ scanErrorDestAccountIdValue: ocrValue });
				if (handleValidation(ocrValue, _item.constraints[0])) {
					this.setState({ destAccountIdValue: ocrValue });
					this.addItemValidated("isValidOcr");
					succedFeaturedDatadog(
						PAGO_SERVICIOS_SCANNER, 
						userInfo.fullstoryIdOperationKey, 
						serviceId, 
						'Termina escáner correctamente'
					);
					this.setState({ isValidOcr: true });
					// Funcionalidad para consultar saldo del codigo de barras
					if (_item.distpatchGetAmount && _item.clientReference && _item.clientReference.length === 2) {
						const clientReferenceValue = ocrValue.substring(_item.clientReference[0],_item.clientReference[1]);

						this.props.getAmountOfTelcelPospago(clientReferenceValue, this.props.serviceId);
						this.setState({ setAmountTelcelPospago: true });
						this.setStepTrack("CS01");
					}

					// Funcionalidad para sacar el monto del codigo de barras
					if (_item.amountSubstr) {
						let amount = getValueFromReference(ocrValue, _item.amountSubstr);
						if (
							parseFloat(ocrAmountValue.replace(/,/g, "")) != amount &&
							!setAmountFromInput
						) {
							getAmountFromOcrData(amount);
							amount > 0
								? this.addItemValidated("isValidAmount")
								: this.deleteItemValidated("isValidAmount");
							this.getCommissions(valueCardId, String(amount));
						}
					}
				} else {
					this.setState({ destAccountIdValue: "", isValidOcr: false });
					this.deleteItemValidated("isValidOcr");
					if (_item.amountSubstr || _item.distpatchGetAmount) {
						setTimeout(() => {
							this.deleteItemValidated("isValidAmount");
						}, 200);
						getAmountFromOcrData(0);
					}
				}
			}

			if (
				!handleValidation(ocrValue, _item.constraints[0]) &&
				window.newRequetsScanner &&
				_item.constraintsAlert
			) {
				this.setState({
					scanError: true,
					destAccountIdValue: "",
					isValidOcr: false,
				});
				this.deleteItemValidated("isValidOcr");
				window.newRequetsScanner = false;
				if (_item.amountSubstr || _item.distpatchGetAmount) {
					setTimeout(() => {
						this.deleteItemValidated("isValidAmount");
					}, 200);
					getAmountFromOcrData(0);
				}
			}
		}

		// Validación para montos desde items(tipo telcel recarga)
		let selectedItemId = "";
		if (this.props.selectedChipValues && this.props.serviceId !== SERVICE_ID_TELCEL_PLANES) {
			if (this.props.selectedChipValues.productId != null) {
				selectedItemId = this.props.selectedChipValues.productId;
				if (selectedItemId != this.state.valueChipProductId) {
					this.setState({ valueChipProductId: selectedItemId });
				}
				if (
					this.props.selectedChipValues.amountValue !=
					this.context.ocrAmountValue.toString().replace(/,/g, "")
				) {
					this.context.getAmountFromOcrData(
						this.props.selectedChipValues.amountValue
					);
					if (!this.props.amountPlan && !this.props.paramsNewOfferTelcel) {
						this.addItemValidated("isValidAmount");
					}
				}
			}
		}

		// flujo para consulta de saldo
		const { amountTelcelPospago, isloadingGetAmountTelcelPospago, responseCheckBalancefrom } = this.props
		const {queryBalanceRequired} = serviceInfo
		if (
			amountTelcelPospago &&
			this.state.setAmountTelcelPospago &&
			!isloadingGetAmountTelcelPospago &&
			responseCheckBalancefrom == "success"
		) {

			const { messageType, responseSubject, responseMessage,
				responseCode, inquiryTelmexId, pendingAmount
			} = amountTelcelPospago
			const image = this.getImgTypeMessage(messageType);
			const buttonTextModalTelcel = queryBalanceRequired ? "Modificar número" : "Pagar otra cantidad"
			const msgBalanceError = queryBalanceRequired ? 
				"No pudimos consultar tu saldo." : 
				"No se ha podido consultar el saldo, ingresa manualmente el monto a pagar"
            
			this.setState({
				titleModalTelcel: responseSubject,
				subtitleModalTelcel: responseMessage,
				imgModalTelcel: image,
				responseCode: responseCode,
				responseCodeMessage: responseMessage,
				setAmountTelcelPospago: false,
				disabledAmountInput: false,
				inquiryTelmexId: inquiryTelmexId
					? inquiryTelmexId
					: this.state.inquiryTelmexId,
			});

			if (
				responseCode == 0 ||
				(serviceId == TELMEX && responseCode == 15)
			) {
				this.context.getAmountFromOcrData(pendingAmount);
				if (pendingAmount > 0) {
					this.addItemValidated("isValidAmount");
				} else {
					this.deleteItemValidated("isValidAmount");
				}
				this.getCommissions(
					this.state.valueCardId,
					String(pendingAmount)
				);
				if (idIsvalidCheckBalanceArcus(isContainerTelcel, serviceId) && pendingAmount == 0) {
					if(!isContainerTelcel){this.taggeoArcusSaldoCero("View alert","Saldo cero")}
					this.setState({
						titleModalTelcel: "No hay saldo pendiente para este servicio",
						imgModalTelcel: "/images/status_warning.png",
						openAlertNoPendingAmount: !isContainerTelcel,
						buttonTextTelcel: "Entendido",
						checkBalanceArcusModalContainerIsVisible : isContainerTelcel,
						typeModalContainerChekBalance : TYPE_MODAL_BALANCE_CERO
					});
				}
				succedFeaturedDatadog(
					PAGO_SERVICIOS_CHECK_BALANCE, 
					userInfo.fullstoryIdOperationKey,
					this.props.serviceId, 
					'Captura monto exitosa'
				)
			} else {
				failedFeaturedDatadog(
					PAGO_SERVICIOS_CHECK_BALANCE, 
					userInfo.fullstoryIdOperationKey, 
					this.props.serviceId, 
					msgBalanceError, 
					'error'
				)
				if (
					(serviceId == SERVICE_ID_TELCEL_POSPAGO &&
						(responseCode == 803 ||
							responseCode == 805 ||
							responseCode == 809 ||
							(responseCode >= 18 && responseCode < 25))) ||
					(responseCode == -1) || amountTelcelPospago.status !== 200 
				) {
					if(this.props.serviceName && this.props.serviceName.toUpperCase() === "AMIGO PAGUITOS"){
						const originAnalyticArray = this.props.originAnalytic? this.props.originAnalytic.split(",") : [];
						this.props.executeTaggeo({
							eventName: "pay_service_or_tae",
							seccion: "servicios",
							subseccion: serviceId && getServicesTelcel(serviceId),
							origen: originAnalyticArray.length > 0? atob(originAnalyticArray[1]).toLowerCase() : "payment_services",
							pantalla: "home amigo paguitos",
							nombreServicio: this.props.serviceName,
							operacion_nombre: "amigo paguitos",
							operacion_tipoRespuesta: "error",
							operacion_variante: "consulta",
							error_tipo: amountTelcelPospago.status || responseCode? responseCode ? "error de sistema" : "error de servicio" : "error de usuario",// o  o ,
							error_mensaje: msgBalanceError,
							error_codigoEstatus: amountTelcelPospago.status || responseCode,
							tipoElemento: "alert",
							nombreElemento: "algo paso",
							trackAction: true,
							isTelcel: true,
						}, true);
					} 
					this.setState({
						titleModalTelcel : "¡Uy, algo pasó!",
						subtitleModalTelcel : msgBalanceError,
						buttonTextTelcel : buttonTextModalTelcel,
						imgModalTelcel: image,
						openModalTelcel: !isContainerTelcel,
						checkBalanceArcusModalContainerIsVisible: isContainerTelcel,
						typeModalContainerChekBalance: TYPE_MODAL_BALANCE_ERROR
					})

					if (responseCode === 20 && serviceId == SERVICE_ID_TELCEL_POSPAGO) {
						this.setState({
							titleModalTelcel: "¡Ups!",
							buttonTextTelcel: buttonTextModalTelcel,
							subtitleModalTelcel:
								"El número que ingresaste no tiene un plan Telcel y no permite la consulta de saldo. Puedes ir a la sección Recarga de saldo.",
							imgModalTelcel: image,
							openModalTelcel: true
						});
					}
					if (responseCode == 18 && serviceId == SERVICE_ID_TELCEL_POSPAGO) {
						this.setState({
							titleModalTelcel: "¡Ups!",
							subtitleModalTelcel:
								"Al parecer, el número que ingresaste no es Telcel. Favor de verificar.",
							buttonTextTelcel: buttonTextModalTelcel,
							imgModalTelcel: image,
							openModalTelcel: true
						});
					}
				} else {
					if (
						this.props.isClaroPartner &&
						serviceId === TELMEX &&
						responseCode === 36
					) {
						this.setState({
							errorCode36_TELMEX: {
								...this.state.errorCode36_TELMEX,
								visible: true,
							},
							openModalTelcel: false,
							isValidOcr: false,
						});
					} else {
						this.setState({
							errorCode36_TELMEX: {
								...this.state.errorCode36_TELMEX,
								visible: false,
							},
							openModalTelcel: !isContainerTelcel,
							checkBalanceArcusModalContainerIsVisible : isContainerTelcel,
							typeModalContainerChekBalance: TYPE_MODAL_BALANCE_ERROR
						});
					}
				}
				this.setState({ disabledAmountInput: queryBalanceRequired });
				this.context.getAmountFromOcrData(0);
				this.deleteItemValidated("isValidAmount");
			}
			const inputTelmex = document.getElementById(
				"pagoDeServicios_destAccountId_TELMEX"
			);
			const amountTelmex = this.context;
			if (amountTelmex.ocrAmountValue > 0) {
				if (
					inputTelmex &&
					inputTelmex.value &&
					inputTelmex.value.length === 10
				) {
					if (this.state.buttonState.disabled) {
						this.context.getAmountFromOcrData(0);
					}
				}
			}
		}

		let contactsValue = this.state.contactsValue;
		if (
			this.props.contactNumber &&
			this.props.contactNumber != this.state.contactsValue &&
			this.state.setContactsValue
		) {
			this.setState({
				setDefaultContactsValue: false,
				contactsValue: this.props.contactNumber,
				destAccountIdValue: this.props.contactNumber,
			});
			if (this.props.selectedChipValues) {
				this.setState({
					valueChipProductId: this.props.selectedChipValues.productId,
				});
			}
			contactsValue = this.props.contactNumber;
			if(this.props.serviceId === SERVICE_ID_TELCEL_POSPAGO){
				this.props.getAmountOfTelcelPospago(
					this.props.contactNumber,
					this.props.serviceId
				)
				this.setState({setAmountTelcelPospago: true})
				if(this.state.isValidOcr){
					this.setState({setDefaultOcrValue: false})
				}
			}
			if(destAccountInput.type === "contacts"){this.addItemValidated("isValidContacts")}
		}

		let cardList = this.props.paymentMethods
			? this.props.paymentMethods.cardList
			: [];
		let hasN2 = this.props.paymentMethods
			? this.props.paymentMethods.hasN2
			: false;
		let isCreditPay = this.props.paymentMethods
			? this.props.paymentMethods.isCreditPay
			: false;
		let claroVideoTitleStyle = { align: "center" };
		let claroVideoTitle = "";
		if (this.state.showClaroVideoTitle) {
			claroVideoTitle = (
				<ClaroParagraph
					fontSize="22px"
					{...claroVideoTitleStyle}
					fontFamily="Amx-Regular"
					margin="20px 0px 20px 0px"
				>
					Contrata un mes
				</ClaroParagraph>
			);
		}

		let borderRadiousStyle = this.props.isClaroPartner ? "5px" : "50em";
			borderRadiousStyle = this.props.isContainerTelcel && !this.props.isClaroPartner ? "25px" : borderRadiousStyle;
		let dataCommissions = this.props.commissionRules
			? this.props.commissionRules
			: this.state.commissionData;
		return (
			<>
				<ModalMessaging
					showModalMessaging={this.state.modalMessaging.show}
					currentFlux={this.state.modalMessaging.flux}
					currentCode={this.state.modalMessaging.code}
					handleOnClickModal={() => {
						this.setState({
							modalMessaging:{
								show:false
							}
						})
					}}
					variant="telcelAnon"
				/>
				<ModalCardLoader isOpen={this.props.loadingTokenizationCard} />
				<Container os={validateUserAgent()}>
					{
						(
							isContainerTelcel && 
							messages &&
							Object.keys(messages).length > 0 &&
							this.state.isOpenCompleteInformationSnackBar
						) &&
						<Snackbar 
							message={ getMessage(messages, "CP0030", "MiniAppTelcel") }
							canMultiAnalytics={this.props.canMultiAnalytics}
							originAnalytic={this.props.originAnalytic}
							serviceInfo={serviceInfo}
							isOpenCompleteInformationSnackBar={this.state.isOpenCompleteInformationSnackBar}
							handleIsOpenCompleteInformationSnackBar={this.handleIsOpenCompleteInformationSnackBar}
							executeTaggeo={this.props.executeTaggeo}
							selectPaymentServiceConf={this.props.selectPaymentServiceConf} />
					}
					{
						(
							messagesTokenization &&
							Object.keys(messagesTokenization).length > 0 &&
							this.state.isOpenCompleteInformationTokenizationSnackBar
						) &&
						<Snackbar 
							canMultiAnalytics={this.props.canMultiAnalytics}
							originAnalytic={this.props.originAnalytic}
							serviceInfo={serviceInfo}
							message={ getMessage(messagesTokenization, "CP0004", "TokenizationCard") }
							isOpenCompleteInformationSnackBar={this.state.isOpenCompleteInformationTokenizationSnackBar}
							handleIsOpenCompleteInformationSnackBar={this.handleIsOpenCompleteInformationTokenizationSnackBar}
							executeTaggeo={this.props.executeTaggeo}
							selectPaymentServiceConf={this.props.selectPaymentServiceConf}
							isAnonimous={this.props.isAnonimous}
						/>
					}
					{claroVideoTitle}
					{Object.entries(this.state.dataConfigInputs).map((input, key) => {
						let newItem = {};
						switch (input[1].type) {
							case "buttonBox":
								return (
									<ButtonBoxContainer 
										input={input[1]}
										dataConfigInputs={this.state.dataConfigInputs}
										isContainerTelcel={this.props.sContainerTelcel}
										amount={this.context.ocrAmountValue} 
										accountValue={this.state.destAccountIdValue}
										accountValueValidLength={this.state.itemDistpatchGetAmountLength} 
										serviceId={this.props.serviceId}
										handleInputButtonFunction = {this.handleInputButtonFunction}
										history= {history}
										tagServiceId={this.props.tagServiceId}
										configImgService={this.props.configImgService}
										handleSetFavValue={this.handleSetFavValue}/>
								)
							case "card":
								break;
							case "commission":
								if (this.props.sdkVersion !== undefined && !this.props.productIdFromUrl) {
									return (
										<>
											{
												isContainerTelcel &&
												parseInt(serviceInfo.categoryPlansId) !== parseInt(CATEGORY_PLANS_ID_PAQUETE_POR_TIEMPO) &&
												(
													serviceId === SERVICE_ID_TELCEL_PLANES ||
													serviceId === SERVICE_ID_TELCEL_RECARGA ||
													serviceId === SERVICE_ID_TELCEL_POSPAGO
												)
													? 
														<>
															<CarouselMegasTelcel 
																origin="BodyPayments" 
																margin={serviceId === SERVICE_ID_TELCEL_PLANES ? "0px 6% 0px 6%" : "20px 6% 20px 6%" }
																handleInputClick={this.handleInputClick}
																handleBannerClick={(evt,bannerURL) => {
																	// serviceConfig selectPaymentServiceConf mapStateTOPro serviceName
																	// package = monto this.props.amountPlan
																	// Tap banner en formulario de Pago
																	const {selectPaymentServiceConf,amountPlan = null} = this.props;
																	console.log("selectedPlan",this.props.selectedPlan,"serviceName",this.props.serviceName,this.props.serviceId)
																	// this.props.serviceId
																	let params = {
																	};
																	switch (this.props.serviceId) {
																		case SERVICE_ID_TELCEL_POSPAGO:
																		case SERVICE_ID_TELCEL_RECARGA:
																			params = {
																				...params,
																				eventName: "pay_service_or_tae",
																				step: "Formulario de pago",
																				action: "Click banner",
																				banner_id:bannerURL,
																				service: assignTagServiceTelcel(serviceId, tagServiceId),
																			};
																			break;

																		case SERVICE_ID_TELCEL_PLANES:
																			params = {
																				...params,
																				eventName: "pay_service_or_tae",
																				step: "Formulario de pago",
																				action: "Click banner",
																				banner_id:bannerURL,
																				service: assignTagServiceTelcel(serviceId, tagServiceId),
																				package: this.props && this.props.selectedPlan && this.props.selectedPlan.amount, // reemplazar con ID,
																			};
																		break;
																		default:
																			params = {};
																			break;
																	}
																	if (
																		(serviceId === SERVICE_ID_TELCEL_PLANES || 
																		serviceId === SERVICE_ID_TELCEL_RECARGA ||
																		serviceId === SERVICE_ID_TELCEL_POSPAGO) &&
																		paymentMethods && 
																		paymentMethods.hasN2 && 
																		creditCardInfo && 
																		creditCardInfo.value !== "claro-pay"
																	) {
																		delete params.banner_id,
																		params = {
																			...params,
																			action: "Click Cambiar N2"
																		}
																	}
																	this.props.executeTaggeo({
																		...params
																	})
																}}
																serviceId={this.props.serviceId}
																amount={this.context.ocrAmountValue}
															/>
															<PlansUpsell 
																selectedPlan={ selectedPlan } 
																selectNextPlan={selectNextPlan} 
																serviceId={serviceId}
																margin={serviceId === SERVICE_ID_TELCEL_PLANES ? "0px 6% 0px 6%" : "20px 6% 20px 6%" } />
														</>														
													:
														<></>
											}
											
											
											<CommisionModule
												commissionData={dataCommissions}
												cardId={this.state.valueCardId}
												key={key}
												amount={this.context.ocrAmountValue}
												isClaroPartner={this.props.isClaroPartner}
												logicType={this.props.serviceInfo.logicType}
												paymentType={this.props.paymentType}
												serviceId={this.props.serviceId}
												isContainerTelcel = {isContainerTelcel}
											/>
										</>										
									);
								}
								break;
							case "ocr":
								if (this.state.errorCode36_TELMEX.visible) {
									input[1] = {
										...input[1],
										subTitle: this.state.errorCode36_TELMEX,
									};
								}
								
								newItem = {
									input: input[1],
									serviceInfo:this.props.serviceInfo,
									handleInputChange: this.handleInputChange,
									value: this.state.destAccountIdValue,
									handleClickTooltip: this.handleClickTooltip,
									serviceName: this.props.serviceName,
									handleInputButtonFunction: this.handleInputButtonFunction,
									isValid: this.state.isValidOcr,
									setDefaultValue: this.state.setDefaultOcrValue,
									isClaroPartner: this.props.isClaroPartner,
									serviceId: this.props.serviceId,
									favoritos: existConfigFavorites(dataConfigInputs),
									configImgService:this.props.configImgService,
									isContainerTelcel: isContainerTelcel,
									fromListFavorites: this.state.fromListFavorites,
								};
								return <DefaultInputClaroSocio {...newItem} key={key} />;
							case "contacts":
								newItem = {
									input: input[1],
									handleInputChange: this.handleInputChange,
									value: contactsValue,
									inputValue:this.state.destAccountIdValue,
									handleClickTooltip: this.handleClickTooltip,
									serviceName: this.props.serviceName,
									handleInputButtonFunction: this.handleInputButtonFunction,
									serviceId: this.props.serviceId,
									isValid: this.state.isValidContacts,
									setDefaultValue: this.state.setDefaultContactsValue,
									isClaroPartner: this.props.isClaroPartner,
									favoritos: existConfigFavorites(dataConfigInputs),
									serviceTA: this.props.serviceInfo.serviceTA,
									isContainerTelcel: isContainerTelcel
								};
								return <ContactInputClaroSocio {...newItem} key={key} />;
							case "select":
								if (this.props.sdkVersion !== undefined) {
									newItem = {
										input: input[1],
										handleInputButtonFunction: this.handleInputButtonFunction,
										value: this.state.valueSelectInput,
										mark: this.state.mark,
										setDefaultValue: this.state.setDefaultSelectValue,
										isClaroPartner: this.props.isClaroPartner,
										logicType: this.props.serviceInfo.logicType,
										isContainerTelcel: isContainerTelcel,
										canCheckBalanceN2: this.props.canCheckBalanceN2,
									};
									return <SelectInputClaroSocio {...newItem} key={key} />;
								}
								break;
							case "select-chips":
								newItem = {
									input: input[1],
									handleInputChange: this.handleInputChange,
									handleInputClick: this.handleInputClick,
									selectedItemId: selectedItemId,
									planInformationQuery:
										this.props.serviceInfo.planInformationQuery,
								};
								if (this.props.isClaroPartner) {
									if (this.props.serviceInfo.planInformationQuery) {
										if (this.props.plans) {
											return (
												<ChipInputClaroSocio
													{...newItem}
													key={key}
													plans={this.props.plans}
												/>
											);
										}
									} else {
										return <ChipInputClaroSocio {...newItem} key={key} />;
									}
								} else {
									if (this.props.serviceInfo.planInformationQuery) {
										if (this.props.plans) {
											return (
												<ClaroChipsBlock 
													key={key} 
													{...newItem} 
													plans={this.props.plans} 
													isContainerTelcel={isContainerTelcel}
													creditCardInfo={this.props.creditCardInfo} />
											);
										}
									} else {
										return <ClaroChipsBlock key={key} {...newItem} isContainerTelcel={isContainerTelcel} />;
									}
								}

							case "button":
								let disableValue = false;
								let margin = "6% 4% 0% 4%";
                                let float = undefined;
								if (input[1].id == "boton1") {
									disableValue = true;
									let referenceInput = _.find(this.props.dataConfigInputs, [
										"id",
										"destAccountId",
									]);
									if (
										referenceInput.field.input.truncateValue ==
										this.state.destAccountIdValue.length
									) {
										disableValue = false;
									}
									margin = isContainerTelcel && !this.props.isClaroPartner 
										? "17px 0px 30px 8px" 
										: margin

									float = isContainerTelcel && !this.props.isClaroPartner 
										? "left" 
										: float
								}

								if (input[1].id == "boton2") {
									margin = isContainerTelcel && !this.props.isClaroPartner 
											? "17px 8px 30px 0px" 
											: margin
									
									float = isContainerTelcel && !this.props.isClaroPartner 
											? "right" 
											: float
								}
								if(isContainerTelcel ){
									return (
										<ClaroButton
											width={!isContainerTelcel ? "42%!important" : "45%"} 
											backgroundColor="#ffffff"
											onClick={(e) =>
												this.handleInputClick(e, input[1].onclickAction)
											}
											color={!isContainerTelcel ? "#50626b!important" : "#7b1fa2!important"}
											border="solid"
											borderColor={!isContainerTelcel ? "#eeeeee" : "#7b1fa2"}
											lineHeight="normal!important"
											height="auto"
											margin={margin}
											key={key}
											disabled={disableValue}
											padding = {isContainerTelcel ? '9px 0px 7px 0px' : undefined}
											fontFamily ='AMX-Bold'
											fontSize = {isContainerTelcel ? '13px' : undefined}
											float={float}
											isContainerTelcel={isContainerTelcel}
											cancelStylesDisabled={isContainerTelcel ? true : false}
										>
											{input[1].title.text}
										</ClaroButton>
									);
								}else{return ""}
							case "cvv":
								newItem = {
									input: input[1],
									handleInputChange: this.handleInputChange,
									value: this.state.valueCvv,
									handleClickTooltip: this.handleClickTooltip,
									serviceName: this.props.serviceName,
									handleInputButtonFunction: this.handleInputButtonFunction,
									isValid: this.state.isValidCvv,
									visible: this.state.visibleInputCvv,
									isClaroPartner: this.props.isClaroPartner,
									logicType: this.props.serviceInfo.logicType,
									handleClickScroll: this.props.handleClickScroll,
									isContainerTelcel: this.props.isContainerTelcel,
									serviceTA: this.props.serviceInfo.serviceTA,
								};
								return (
									<CvvInputClaroSocio
										{...newItem}
										key={key}
										serviceId={this.props.serviceId}
									/>
								);
							case "description":
								newItem = {
									input: input[1],
									handleInputChange: this.handleInputChange,
									value: this.state.valueDescription,
									handleClickTooltip: this.handleClickTooltip,
									serviceName: this.props.serviceName,
									handleInputButtonFunction: this.handleInputButtonFunction,
									isValid: this.state.isValidDescription,
									logicType: this.props.serviceInfo.logicType,
									handleClickScroll: this.props.handleClickScroll,
									isClaroPartner: this.props.isClaroPartner,
                  isContainerTelcel: isContainerTelcel,
								};
								return <DescriptionInputClaroSocio {...newItem} key={key} />;
							default:
								if (input[1].id == "amount") {
									if (
										this.state.setDefaultAmount &&
										input[1].field.input.value != "" &&
										input[1].field.input.value != undefined &&
										this.context.ocrAmountValue != input[1].field.input.value
									) {
										this.context.getAmountFromOcrData(
											input[1].field.input.value
										);
									}	
									
									/*
										giftImage es la imagen que se muestra junto al 
										monto en pago de servicios, es para planes y pago
										de factura
									*/
									let giftImage = undefined;

									if (this.props.selectedPlan && this.props.selectedPlan.promotions) {
										giftImage = this.props.selectedPlan.promotions.PromotionMegasGift
									}

									if (
										isContainerTelcel &&
										serviceId === SERVICE_ID_TELCEL_POSPAGO &&
										creditCardInfo &&
										appSyncValues &&
										appSyncValues.banks &&
										appSyncValues.banks[0].properties &&
										appSyncValues.banks[0].properties.BILL_PAYMENT_BENEFIT_IMAGE &&
										appSyncValues.banks[0].properties.MIN_BILL_PAYMENT_BENEFIT &&
										(
											parseFloat(this.context.ocrAmountValue.replaceAll(",", "")) >= 
											parseFloat(appSyncValues.banks[0].properties.MIN_BILL_PAYMENT_BENEFIT)
										)
									) {
										giftImage = appSyncValues.banks[0].properties.BILL_PAYMENT_BENEFIT_IMAGE
									}

									/* Fin de giftImage */

									newItem = {
										input: input[1],
										handleInputChange: this.handleInputChange,
										value: this.context.ocrAmountValue,
										serviceName: this.props.serviceName,
										isClaroPartner: this.props.isClaroPartner,
										amountPlan: this.props.amountPlan,
										logicType: this.props.serviceInfo.logicType,
										disabledAmountInput: this.state.disabledAmountInput,
										userAgentIsAndroid: validateUserAgent() === "android",
										serviceId: this.props.serviceId,
										isDisabledButtonArcusGetAmount: this.state.isDisabledButtonArcusGetAmount,
										handleInputButtonFunction: this.handleInputButtonFunction,
										dataConfigInputs: this.props.dataConfigInputs,
										handleInputClick: this.handleInputClick,
										canManageFavorites: this.props.canManageFavorites,
										giftImage: giftImage,
										selectedPlan: this.props.selectedPlan,
										creditCardInfo: creditCardInfo,
									};
									return <AmountInputClaroSocio {...newItem} key={key} isContainerTelcel={isContainerTelcel} />;
								} else {
									newItem = {
										input: input[1],
										handleInputChange: this.handleInputChange,
										value: "",
										handleClickTooltip: this.handleClickTooltip,
										serviceName: this.props.serviceName,
										handleInputButtonFunction: this.handleInputButtonFunction,
										serviceId: this.props.serviceId,
									};
									return <DefaultInputClaroSocio {...newItem} key={key} />;
								}
						}
					})}

					{
						this.props.userInfo && 
						this.props.userInfo.existWhiteList && 
						tapToappFlag && 
						showBannerTapToApp && 
						!isContainerTelcel &&
						tapToAppParams && 
						tapToAppParams.tapToAppEnabled &&
						tapToAppParams.tapToAppSupported &&
							<img 
								src={
										"https://uatmalogos.claropay.com/tap/Banner.png"
								} 
								alt="Banner.png" 
								style={{width: "-webkit-fill-available", margin: "2% 2% 15px 2%"}}
								onClick={(event) => {
									if(!isContainerTelcel && !this.props.isAnonimous){
										this.props.executeTaggeo({
												eventName: "pay_service_or_tae",
												claro_id: this.props.userInfo && this.props.userInfo["claro-profile.person.claroid"],
												msisdn: this.props.userInfo && 
													this.props.userInfo.msisdnEncrypt && 
													this.props.userInfo.msisdnEncrypt.data,
												step: "Formulario de pago",
												action: "Click banner",
												banner_id: "pago sin contacto",
												service_id: this.props.serviceInfo.serviceId,
												product_id: this.props.productIdFromPlan ? this.props.productIdFromPlan : "",
										});
    							} 
									this.handleInputClick(
										event, 
										"tapToApp", 
										{
											value: "tap-to-app",
											id: "tap-to-app",
											mark : "990",
											text: "Pagar sin contacto"
										}
									)}
								}
							/>
					}
					{
						this.props.showTermsInForm && !this.props.hasProminentDate &&
						<TermsAndPrivacy />
					}

					<ClaroPadding padding={(this.props.isContainerTelcel)?'24px 2% 2% 2%':'2%'} style={{marginBottom:"20px"}}>
						<ClaroParagraph
							{...button.align}
							{...button.weight}
							{...button.style}
							style={{ margin: marginButtonContinue, paddingBottom: "10px" }}
						>
							{this.props.isLoadingCommisSionRules ||
								this.props.isloadingGetAmountTelcelPospago ||
								buttonContinueLoading ? (
								<ClaroLoadBtn backgroundColor="#000000" disabled isContainerTelcel={isContainerTelcel}></ClaroLoadBtn>
							) : (
								<ClaroButton
									id="claro_button"
									backgroundColor={isContainerTelcel ? "#7b1fa2" : "#000000"}
									{...this.state.buttonState}
									onClick={this.handleSubmit}
									borderRadiusClaro={borderRadiousStyle}
									isClaroPartner={this.props.isClaroPartner}
									innerRef={this.buttonSubmitRef}
									fontFamily="AMX-Bold"
                                	isContainerTelcel={isContainerTelcel}
								>
									{this.state.buttonText}
									{serviceInfo.logicType === "sears" ? (
										<img
											src={"./images/path_continuar_blanca.svg"}
											style={{
												margin: "0px 0px 2px 5px",
												verticalAlign: "middle",
											}}
										/>
									) : (
										""
									)}
								</ClaroButton>
							)}
						</ClaroParagraph>
						{isContainerTelcel && this.props.showCopyVerify && this.props.showCopyVerify.active &&
							<ClaroParagraph
								fontSize={this.props.showCopyVerify.fontSize || "12px"}
								fontColor={this.props.showCopyVerify.fontColor || "#000000"}
								fontFamily={this.props.showCopyVerify.fontFamily || "Amx-Regular"}
								align={this.props.showCopyVerify.align || "center"}
								margin={this.props.showCopyVerify.margin || "0px"}
								display=""
							>
								{this.props.showCopyVerify.text}
							</ClaroParagraph>
						}
					</ClaroPadding>
				</Container>
				<ModalValidationNumberAP
					isOpen={this.state.modalValidationNumberAPIsOpen}
					backgroundColor='rgba(0,0,0,0.1)'
					titleText={this.state.modalValidationNumberAPTitle}
					subtitleText={this.state.modalValidationNumberAPSubtitle}
					btn1Background='#fff'
					btn1Color={isContainerTelcel ? '#7b1fa2' : '#000'}
					btn1Text={this.state.ModalValidationNumberAPBtn1Text}
					btn1Action={this.btn1Action}
					btn2Background={isContainerTelcel ? '#7b1fa2' : '#000'}
					btn2Color='#fff'
					btn2Text={this.state.ModalValidationNumberAPBtn2Text}
					btn2Action={this.btn2Action}
					isContainerTelcel={isContainerTelcel}
					marginTitle={isContainerTelcel ? "0px 0px 20px 0px" : undefined}
					marginTextDetail={isContainerTelcel ? "0px 0px 30px 0px" : undefined}
				/>
				<ClaroTooltip
					closeImg={isContainerTelcel ? `${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}icono_salir_contenedor.png` : undefined}
                    fontFamilyTitle="AMX-Bold" 
                    fontFamilySubtitle="AMX-Regular" 
					isOpen={this.state.openToolTip}
					addCloseEfect={this.state.addCloseEfect}
					onclickCloseTooltip={this.onclickCloseTooltip}
					text={this.state.textTitleTooltip}
					srcImage={this.state.imgTooltip}
					srcImagePosition={this.state.imgTooltipPosition}
					marginTitle={this.state.marginTitleTooltip}
					heightImg={this.state.heightImg}
					colorButton="#797878"
					fontSizeTitle={this.state.fontSizeTitleTooltip}
					height={this.state.heightTooltip}
					colorTitle={this.state.fontColorTooltip}
					fontSizeButton="23px!important"
					fadeInTime="1s"
					fadeIn
					cubicBezier="cubic-bezier(0.9, 0, 0.9, 1)"
					widthImg={this.state.imgTooltipWidth}
					textSubtitle={this.state.textSubtitle}
					colorSubtitle={isContainerTelcel ? "#000000" : "#838383"}
					fontWeightTitle="bold!important"
					fontWeightSubtitle="normal!important"
					fontSizeSubtitle="12px"
					paddingTitle="3px 16px 0px 16px"
					marginButton="0px 0px 0px 0px"
					boxShadow="none"
				/>
				<ModalCardLoader
					isOpen={
						this.props.showLoaderWaitSubmit ||
						this.props.showLoaderOnDoubleBack ||
						(this.props.isLoadingReminderReducerServices ||
						(
							(
								paramsNewOfferTelcel && paramsNewOfferTelcel.cvv &&
								setAutomaticOnclick && this.props.serviceId !== SERVICE_ID_TELCEL_RECARGA
							) ||
							(
								paramsNewOfferTelcel &&
								this.props.isloadingGetAmountTelcelPospago
							) ||
							(
								paramsNewOfferTelcel &&
								this.props.isLoadingCommisSionRules
							)
						))
					}
				/>
				<SelectCardClaroSocio
					backgroundColor="rgba(0,0,0,0.8)"
					isOpen={
						!this.props.isLoadingGetPaymentMethods &&
						this.state.openSelectCardClaroSocio
					}
					colorButton="#797878"
					height="70%"
					fontSizeButton="23px!important"
					marginButton="0px 0px 0px 10px"
					fadeInTime="1s"
					cubicBezier="cubic-bezier(0.9, 0, 0.9, 1)"
					fadeIn
					addCloseEfect={false}
					cardItems={cardList}
					hasN2={hasN2}
					closeSelectCardClaroSocio={this.closeSelectCardClaroSocio}
					handleInputClick={this.handleInputClick}
					selectValue={this.state.valueCardId}
					activeN2={this.validateActiveN2()}
					isCreditPay={isCreditPay}
					isClaroPartner={this.props.isClaroPartner}
          			isContainerTelcel={this.props.isContainerTelcel}
					showAdvancementPayMethodInList={this.props.showAdvancementPayMethodInList ||  this.state.showAdvancementPayMethod}
					executeTaggeo={this.props.executeTaggeo}
					serviceInfo={serviceInfo}
					canMultiAnalytics={this.props.canMultiAnalytics}
					originAnalytic={this.props.originAnalytic}
					userInfo={this.props.userInfo}
					tapToappFlag={tapToappFlag}
					tapToAppParams={tapToAppParams} 
					productId={this.state.valueChipProductId}
				/>
				<SelectCardAnonimous 
					height="75%"
					backgroundColor="rgba(0,0,0,0.1)"
					isContainerTelcel={this.props.isContainerTelcel}
					isOpen={
						this.state.openSelectCardAnonimous
					}
					fadeInTime="1s"
					cubicBezier="cubic-bezier(0.9, 0, 0.9, 1)"
					fadeIn
					addCloseEfect={false}
					handleCloseSelectCardAnonimous={(evt,bannerImageURL) => {
						this.setState({ openSelectCardAnonimous: false })}
					}
					isAnonimous={this.props.isAnonimous}
					handleInputClick={this.handleInputClick}
					planCategory={this.props.planCategory}
					planBenefits={this.props.planBenefits}
					userInfo={this.props.userInfo}
					handleOpenModalCardHE={() => this.setState({isOpenModalCardHE: true})}
					serviceId={this.props.serviceId}
					serviceInfo={serviceInfo}
					isUnificationFlow={this.props.isUnificationFlow}
					handleValidateIfSentToTicket={this.props.handleValidateIfSentToTicket}	
					handleShowLoaderWaitSubmit={this.props.handleShowLoaderWaitSubmit}
					canMultiAnalytics={this.props.canMultiAnalytics}
					closeTokenizationCard={this.closeTokenizationCard}
					originAnalytic={this.props.originAnalytic}
                    setAddCardFormDataHandler={this.setAddCardFormDataHandler}
				/>
					
				<ModalCardOk
					isOpen={this.state.openAlertNoPendingAmount}
					paddingCard="0px 30px 0px 30px"

					srcImage={this.state.imgModalTelcel}
					imageMargin="20px 0px 16px 0px"
					heightImg="56"
					widthImg="56"
					onClickImg={()=>false}

					text={this.state.titleModalTelcel}
					fontFamilyTitle="AMX-Medium"
					fontSizeTitle="20px"
					colorTextModal1="#1e1e1e"
					marginTitle="0px 0px 32px 0px"
					fontWeightTitle="normal"

					buttontext={this.state.buttonTextTelcel}
					widthButton="200px"
					marginButton="0px auto"
					fontFamilyButton="AMX-Bold"
					colorButton="#fff"
					backgroundColorButton="#000"
					fontSizeButton="16px"

					onclickModal={this.onclickModalNoPendingAmount}
				/>
				<ModalCardOk
					isOpen={this.state.openModalTelcel}
					srcImage={this.state.imgModalTelcel}
					text={this.state.titleModalTelcel}
					textdetail={this.state.subtitleModalTelcel}
					buttontext={this.state.buttonTextTelcel}
					onclickModal={(e) => this.handleModalClaroOk(e)}
					fontSizeDetail="12px"
					textLink="Reintentar"
					textDecorationLinkButton="underline"
					colorTextModal1={isContainerTelcel ? '#222222' : undefined}
					fontFamilyTextdetail={isContainerTelcel ? "AMX-Regular" : undefined}
					fontSizeTitle={isContainerTelcel ? '20px' : '26px'}
					backgroundColorButton={isContainerTelcel ? '#7b1fa2' : '#202020'}
					fontFamilyButton='AMX-Bold'
					fontSizeButton={isContainerTelcel ? '16px' : '4.05vw '}
					fontFamilyTitle='AMX-Bold'
					colorTextdetail={isContainerTelcel ? "#757575" : undefined}
					marginTitle={isContainerTelcel ? "0px 0px 20px 0px" : undefined}
					marginTextDetail={isContainerTelcel ? "0px 0px 30px 0px" : undefined}
				/>
				<ModalCardOk
					isOpen={this.state.openModalUpdateCard}
					srcImage="data:image/png;base64,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"
					text="¡Hey!"
					buttontext="Actualizar ahora"
					textdetail="Es necesario que actualices los datos de esta tarjeta para que puedas utilizarla"
					onclickModal={this.onclickUpdateCard}
					textLink="Hacerlo en otro momento"
					textDecorationLinkButton="underline"
					fontFamilyTitle='AMX-Bold' 
					colorTextModal1={isContainerTelcel ? '#222222' : undefined}
					fontFamilyTextdetail={isContainerTelcel ? "AMX-Regular" : undefined}
					fontSizeTitle={isContainerTelcel ? '20px' : '26px'}
					backgroundColorButton={isContainerTelcel ? '#7b1fa2' : undefined}
					fontFamilyButton= 'AMX-Bold' 
					fontSizeButton={isContainerTelcel ? '16px' : '4.05vw '}
					marginButton={isContainerTelcel ? "0 auto 28px auto" : undefined}
					fontSizeDetail={isContainerTelcel ? "16px" : "12px"}
					colorTextdetail={isContainerTelcel ? "#757575" : undefined}
					textSizeLinkButton={isContainerTelcel ? "16px" : "10px"}
					fontFamilyLinkButton='AMX-Bold' 
					textColorLinkButton={isContainerTelcel ? "#0071d1" : "#000"}
					marginTitle={isContainerTelcel ? "0px 0px 20px 0px" : undefined}
					marginTextDetail={isContainerTelcel ? "0px 0px 30px 0px" : undefined}
				/>
				{
					<ModalCardOk
						isOpen={this.state.scanError}
						srcImage="data:image/png;base64,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"
						text={"¡Ups!"}
						buttontext={"Ok"}
						textdetail={
							"Código inválido. Por favor verifica e inténtalo de nuevo"
						}
						onclickModal={() => this.setState({ scanError: false })}
						fontFamilyTitle='AMX-Bold' 
						colorTextModal1={isContainerTelcel ? '#222222' : undefined}
						fontFamilyTextdetail={isContainerTelcel ? "AMX-Regular" : undefined}
						fontSizeTitle={isContainerTelcel ? '20px' : '26px'}
						backgroundColorButton={isContainerTelcel ? '#7b1fa2' : undefined}
						fontFamilyButton='AMX-Bold'
						fontSizeButton={isContainerTelcel ? '16px' : '4.05vw '}
						fontSizeDetail={isContainerTelcel ? "16px" : "12px"}
						colorTextdetail={isContainerTelcel ? "#757575" : undefined}
						marginTitle={isContainerTelcel ? "0px 0px 20px 0px" : undefined}
						marginTextDetail={isContainerTelcel ? "0px 0px 30px 0px" : undefined}
					/>
				}
				{
					<ModalCardOk
						isOpen={this.state.amountMinAlert}
						srcImage="data:image/png;base64,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"
						text={
							"Para poder usar tu crédito necesitas pagar una factura con un monto mínimo de  $" +
							formatToCurrency(AMOUNT_MIN_TO_USE_CREDIT)
						}
						buttontext={"Entendido"}
						onclickModal={() => this.setState({ amountMinAlert: false })}
						fontSizeTitle={isContainerTelcel ? '20px' : '26px'}
						fontFamilyTitle='AMX-Bold'
						colorTextModal1={isContainerTelcel ? '#222222' : undefined}
						backgroundColorButton={isContainerTelcel ? '#7b1fa2' : undefined}
						fontFamilyButton='AMX-Bold'
						fontSizeButton={isContainerTelcel ? '16px' : '4.05vw '}
						marginTitle={isContainerTelcel ? "0px 0px 20px 0px" : undefined}
					/>
				}

				<ModalCardHE 
					isOpen={this.state.isOpenModalCardHE}
					close={()=>this.setState({isOpenModalCardHE: false})}
					canMultiAnalytics={this.props.canMultiAnalytics}
					serviceInfo={serviceInfo}
					originAnalytic={this.props.originAnalytic}
					isContainerTelcel={this.props.isContainerTelcel}
				/>
				<ModalCardOk
						isOpen={openModalComissionError}
						srcImage="data:image/png;base64,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"
						text={"¡Lo sentimos!"}
						buttontext={"Ok"}
						textdetail={"Por el momento este servicio no está disponible. Por favor, intenta más tarde."}
						onclickModal={(e) =>{
								this.setState({openModalComissionError: false})
								if(paramsNewOfferTelcel){window.history.back()}
							}
						}
						fontSizeDetail="12px"
				/>
				<ModalCloseModal
					isOpen={this.state.openNFCSettings}
					srcImage="data:image/png;base64,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"
					text={"Enciende tu NFC"}
					textdetail={"Para continuar debes encender el NFC de tu celular. Dirígete a los ajustes, busca NFC y habilita la opción"}
					buttontext={"Ir a configuración"}
					onclickModal={() => {
						this.openSettingsNFC();
					}}
					onClose={() => this.onCloseModalNFCSettings()}
					fontSizeDetail="16px"
					widthButton={"87.111vw"}
					borderRadiusCard={"5px"}
					textDecorationLinkButton="underline"
					colorTextModal1={isContainerTelcel ? '#222222' : undefined}
					fontFamilyTextdetail={isContainerTelcel ? "AMX-Regular" : "AMX-Regular"}
					fontSizeTitle={isContainerTelcel ? '20px' : '26px'}
					backgroundColorButton={isContainerTelcel ? '#7b1fa2' : '#202020'}
					fontFamilyButton='AMX-Bold'
					fontSizeButton={isContainerTelcel ? '16px' : '4.05vw '}
					fontFamilyTitle='AMX-Bold'
					colorTextdetail={isContainerTelcel ? "#757575" : undefined}
					marginTitle={isContainerTelcel ? "0px 0px 20px 0px" : undefined}
					marginTextDetail={isContainerTelcel ? "0px 0px 30px 0px" : undefined}
				/>
				<>{
						this.state.showTokenizationCard && 
						isContainerTelcel && 
						this.props.isUnificationFlow ?
							<TokenizationCardContainer
								{...this.props}
								singlePageConfig ={{
									allWidth: false,
									buttonLabel: "Continuar",
									autofocus: false,
									backgroundColor: "white",
								}} 
								hasCards={this.props.paymentMethods
									? this.props.paymentMethods.cardList
									: []}
								showHeader={this.state.isCardCustomer && this.state.isCardCustomer.success === false ? true : false}
								isCardCustomer={this.state.isCardCustomer}
								closeTokenizationCard={this.closeTokenizationCard}
								updateCard={this.state.updateWithTokenization}
							/>		
						:  
							this.state.showTokenizationCard &&
							isContainerTelcel &&
							!this.props.isUnificationFlow ? (
							<TokenizationCardContainer
								{...this.props}
								hasCards={
									this.props.paymentMethods
										? this.props.paymentMethods.cardList
										: []
								}
								closeTokenizationCard={this.closeTokenizationCard}
								updateCard={this.state.updateWithTokenization}
							/>
						) :
					this.state.showTokenizationCard	&& !isContainerTelcel &&
						<TokenizationCardContainer
							{...this.props}
							tapToapp={this.state.tapToapp}
							closeTokenizationCard={this.closeTokenizationCard}
							updateCard={this.state.updateWithTokenization}
						/>			
					}</>

				{ checkBalanceArcusModalContainerIsVisible ?
					<ModalCheckBalanceTelcel 
						open={checkBalanceArcusModalContainerIsVisible} 
						onClose={() => this.setState({ checkBalanceArcusModalContainerIsVisible: false })}
						typeModal={typeModalContainerChekBalance}
					/> : <></>
				}
			</>
		);
	}
}

BodyPaymentFormClaroSocio.contextType = GenericFormContext;

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPaymentMethods,
			getAmountOfTelcelPospago,
			setSelectedChipValues,
			getCommissionInfo,
			addContactToRecents,
			setCreditCardInfo,
			setTrackSteps,
			getOCRScanner,
			executeTaggeo,
			getHasDomiciliation,
			setShowAdvancementMiniBanner,
			setAdvancementPayMethod,
			setPaymentMethod,
			setStartEventOnboardingIsOver,
			setTokenizationCard,
			setSnackBarSuccess,
			setLoadingTokenizationCard,
			setVerifyNfc,
			setResponseReadingNfc,
			setOpenPayMethodModal,
			setOpenFluxAddCard
		},
		dispatch
	);
}

function mapStateToProps(state) {
	const { payments, domiciliationReducer:{hasDomiciliationServiceResponseSuccess},favoritesRefReducer,payReminderReducer } = state;
	const contactsList = selectPaymentServiceContacts(payments);
	const ocrScannerData = selectOCRScannerData(payments);
	const canSendId = getCanSendId(state);
	const listFavServices = getListFavsServices(favoritesRefReducer);
	const listReminder = getListReminder(payReminderReducer);
	const hasCredit = getHasCreditFromUrl(state);
	const bundleVersion = getBundleVersionFromUrl(state);
	const userInfo = getUserInfoSelector(state)
	const originAnalytic = getOriginParamsSelector(state);
	const tapToappFlag = getCanTapToAppSelector(state);
	const tapToAppParams = getTapToAppParamsSelector(state);
	const verifyNfcState = getVerifyNfcSelector(state);
	const responseReadingNFC = getResponseReadingNfcSelector(state);
	const isAnonimous = payments.isAnonimous;
	const addCardFormData = payments.addCardFormData;
	const {
		setAdvancementPayMethodValue,
		startEventOnboardingIsOver,
		appSyncValues,
		messages,
		messagesTokenization,
		cvvForAnonimous,
		showLoaderOnDoubleBack,
		showTermsInForm,
		hasProminentDate,
		urlFlags,
		openPayMethodModal,
		openFluxAddCard
	} = payments;
	return {
		selectPaymentServiceConf: selectPaymentServiceConf(state.payments),
		paymentMethods: state.payments.paymentMethods,
		ocrScannerData,
		isLoadingGetPaymentMethods: state.payments.isLoadingGetPaymentMethods,
		isloadingGetAmountTelcelPospago:
		state.payments.isloadingGetAmountTelcelPospago,
		listFavServices,
		listReminder,
		isLoadingCommisSionRules: state.payments.isLoadingCommisSionRules,
		isLoadingReminderReducerServices: state.payReminderReducer.isLoading,
		commissionRules: state.payments.commissionRules,
		amountTelcelPospago: state.payments.amountTelcelPospago,
		selectedChipValues: state.payments.selectedChipValues,
		userInfo: userInfo,
		contactsList,
		contactInfo: state.payments.contactInfo,
		creditCardInfo: state.payments.cardInfo,
		plans: state.payments.plans,
		errorCheckBalance: state.payments.errorCheckBalance,
		responseCheckBalancefrom: state.payments.responseCheckBalancefrom,
		trackId: state.payments.trackId,
		activeN2: state.payments.activeN2,
		canSendId,
		hasCredit,
		lineNumber: payments.lineNumber,
		originOfPayment: payments.originOfPayment,
		bundleVersion: bundleVersion,
		setPaymentMethodInfo: payments.setPaymentMethodInfo,
		paymentAmountFromUrl: payments.getPaymentAmountFromUrl,
		productIdFromUrl: payments.getProductIdFromUrl,
		isAnonimous,
		startEventOnboardingIsOver,
		addCardFormData,
		hasDmResponse : hasDomiciliationServiceResponseSuccess,
		setAdvancementPayMethodValue,
		paramsFromurl: state.payments.params,
		appSyncValues: appSyncValues,
		messages,
		messagesTokenization,
		cvvForAnonimous,
		showLoaderOnDoubleBack,
		tokenizationCard: getTokenizationCardSelector(state),
		tokenizationOn: getTokenizationOnSelector(state),
		commissionInfoError : payments.commissionInfoError,
		canRegisterEmail: getCanRegisterEmailSelector(state),
		loadingTokenizationCard: getLoadingTokenizationCardSelector(state),
		canMultiAnalytics: getCanMultiAnalytics(state),
		originAnalytic,
		tapToappFlag,
		tapToAppParams,
		verifyNfcState,
		responseReadingNFC,
		showTermsInForm,
		isUnificationFlow: state.payments.unificationFlow,
		hasProminentDate,
		canR1: state.payments.canR1,
		canR1Flag: state.payments.canR1Flag,
		canCheckBalanceN2: getCanCheckBalanceN2(state),
		urlFlags,
		openPayMethodModal,
		openFluxAddCard
	};
}

BodyPaymentFormClaroSocio = connect(
	mapStateToProps,
	mapDispatchToProps,
	
)(BodyPaymentFormClaroSocio);

export default BodyPaymentFormClaroSocio;
